import React from "react";
import { GoToTop, LayoutMain, StaticPageLayout } from "../../components/common";
import "./Terms.css";

function Terms(
  {
    headline1 = "Allgemeine Geschäftsbedingungen des Kamikaze Travel e.U. als Reiseveranstalter",
  },
  {
    headline2 = "Allgemeine Geschäftsbedingungen des Kamikaze Travel e.U. als Reisevermittler",
  }
) {
  return (
    <LayoutMain>
      <GoToTop />

      <div className="terms-header">
        <h2>Allgemeine Geschäftsbedingungen</h2>
        <div className="terms-links">
          <a href="#section-headline1">AGB Reiseveranstalter</a>
          <a href="#section-headline2">AGB Reisevermittler</a>
        </div>
      </div>

      <StaticPageLayout className="terms-layout" title={headline1}>
        <h3 id="section-headline1">1. Geltungsbereich und Definitionen </h3>
        <p>
          1.1. Ein Reiseveranstalter ist ein Unternehmer, der entweder direkt
          oder über einen anderen Unternehmer oder gemeinsam mit einem anderen
          Unternehmer Pauschalreisen (iSd § 2 Abs 2 PRG) zusammenstellt und
          vertraglich zusagt oder anbietet (vgl § 2 Abs 7 PRG). Der
          Reiseveranstalter erbringt seine Leistungen entsprechend den
          gesetzlichen Bestimmungen, insbesondere dem Pauschalreisegesetz (PRG),
          sowie der Pauschalreiseverordnung (PRV) mit der Sorgfalt eines
          ordentlichen Unternehmers. Ein Unternehmer ist jede natürliche oder
          juristische Person, der Unternehmereigenschaft nach § 1 KSchG zukommt
          (vgl § 2 Abs 9 PRG). Im nachfolgenden meint Reiseveranstalter das
          Unternehmen KaMikaze Travel.
        </p>
        <p>
          1.2. Die Allgemeinen Geschäftsbedingungen gelten als vereinbart, wenn
          sie – bevor der Reisende durch eine Vertragserklärung an einen Vertrag
          gebunden ist – übermittelt wurden oder der Reisende deren Inhalt
          einsehen konnte. Sie ergänzen den mit dem Reisenden abgeschlossenen
          Pauschalreisevertrag. Bucht der Reisende für Dritte (Mitreisende),
          bestätigt er damit, dass er von diesen Dritten bevollmächtigt wurde,
          ein Anbot für sie einzuholen, die allgemeinen Geschäftsbedingungen für
          sie zu vereinbaren sowie einen Pauschalreisevertrag für sie
          abzuschließen. Der Reisende, der für sich oder für Dritte eine Buchung
          vornimmt, gilt damit als Auftraggeber und übernimmt analog im Sinne
          des § 7 Abs 2 PRG, sofern nicht eine andere Vereinbarung getroffen
          wird, die Verpflichtungen aus dem Vertrag mit dem Reiseveranstalter
          (Zahlungen, Rücktritt vom Vertrag usw).
        </p>
        <p>
          1.3. Reisender ist jede Person, die einen den Bestimmungen des
          Pauschalreisegesetzes unterliegenden Vertrag (z.B.
          Pauschalreisevertrag) zu schließen beabsichtigt oder die aufgrund
          eines solchen Vertrags berechtigt ist, Reiseleistungen in Anspruch zu
          nehmen.
        </p>
        <p>
          1.4. Die Homepage www.kamikaze-travel.at und www.kamikaze-travel.com
          von Kamikaze Travel e.U. dienen als bloße Werbemittel. Die darin
          präsentierten Pauschalreisen und sonstigen Leistungen stellen sofern
          nicht darauf im Einzelfall hingewiesen wurde keine Anbote dar (vgl.
          2.2.). Für die Reise und Grundlage des Reisevertrages gilt die zum
          Zeitpunkt des Vertragsabschlusses aktuelle Version.
        </p>
        <p>
          1.5. Unter einem Pauschalreisevertrag versteht man den Vertrag, der
          zwischen dem Reiseveranstalter und dem Reisenden über eine
          Pauschalreise abgeschlossen wird.
        </p>
        <p>
          1.6. Unter dem Reisepreis wird der im Pauschalreisevertrag angegebene,
          vom Reisenden zu bezahlende Betrag verstanden.
        </p>
        <p>
          1.7. Sofern nicht anders ausgeschrieben, sind die von KaMikaze Travel
          angebotenen und durchgeführten Reisen für Personen mit eingeschränkter
          Mobilität aufgrund der Art der Durchführung und ihrem Charakter nicht
          geeignet.
        </p>
        <p>
          1.8. Unvermeidbare und außergewöhnliche bzw. unvorhersehbare Umstände
          sind Vorfälle/Ereignisse/Gegebenheiten außerhalb der Sphäre/Kontrolle
          desjenigen, der sich auf sie beruft und deren Folgen sich auch dann
          nicht hätten vermeiden lassen, wenn alle zumutbaren Vorkehrungen
          getroffen worden wären (z.B. Kriegshandlungen, schwerwiegende
          Beeinträchtigungen der Sicherheit wie Terrorismus, Ausbrüche schwerer
          Krankheiten, Epidemien, Pandemien, Naturkatastrophen,
          Witterungsverhältnisse (z.B. Schnee, Regen, Lawinen, Muren etc.), die
          eine sichere Reise verhindern etc.) (vgl. § 2 Abs 12 PRG).
        </p>
        <p>
          1.9. Das Pauschalreisegesetz und die Allgemeinen Geschäftsbedingungen
          gelten nicht für Pauschalreiseverträge, die auf der Grundlage einer
          allgemeinen Vereinbarung über die Organisation von Geschäftsreisen
          (z.B. Rahmenvertrag) zwischen zwei Unternehmern geschlossen werden.
        </p>
        <h3>2. Aufgaben des Reiseveranstalters </h3>
        <p>
          2.1. Ausgehend von den Angaben des Reisenden erstellt KaMikaze Travel
          für den Reisenden Reisevorschläge bzw. sind Reisevorschläge auf der
          Website von www.kamikaze-travel.at und kamikaze-travel.com einsehbar
          und abrufbar. Diese sind unverbindlich, es handelt sich deshalb –
          sofern nicht gesondert gekennzeichnet – noch nicht um Anbote iSd § 4
          PRG. Können aufgrund der Angaben des Reisenden keine Reisevorschläge
          erstellt werden (keine Varianten, keine Leistungen etc.) so weist
          Kamikaze Travel e.U. den Reisenden darauf hin. Die Reisevorschläge
          KaMikaze Traveleren auf den Angaben bzw. Eingaben des Reisenden in der
          Anfrage/Buchungsmaske, weshalb unrichtige und/oder unvollständige
          Angaben durch den Reisenden - mangels Aufklärung durch den Reisenden -
          Grundlage der Reisevorschläge sein können. Bei der Erstellung von
          Reisevorschlägen können beispielsweise (ohne Anspruch auf
          Vollständigkeit), die Höhe des Preises, Fachkompetenzen des
          Leistungsträgers, Rabatte, das Bestpreisprinzip und anderes mehr
          allenfalls als Parameter herangezogen werden.
        </p>
        <p>
          2.2. Hat der Reisende ein konkretes Interesse an einem der vom
          Reiseveranstalter ihm unterbreiteten Reisevorschläge, dann erstellt
          KaMikaze Travel auf KaMikaze Travels des Reisevorschlages ein
          Reiseanbot gemäß den Vorgaben des § 4 PRG, soweit diese für die Reise
          von Relevanz sind. Allenfalls wird aufgrund der konkreten Anfrage auf
          der Website von Kamikaze Travel dem Reisenden ein buchbares Anbot
          aufgrund der Angaben erstellt und dem Reisenden zur Kenntnis gebracht,
          welches dieser sofort buchen kann. Sollte das nicht der Fall sein, so
          erstellt Kamikaze Travel ein Reiseanbot. Ein von Kamikaze Travel auf
          Anfrage des Reisenden erstelltes Reiseanbot bindet Kamikaze Travel
          längstens 24 Stunden. Änderungen der im Reiseanbot enthaltenen
          vorvertraglichen Informationen aufgrund von Preis- oder
          Leistungsänderungen sind möglich, sofern sich Kamikaze Travel dies im
          Reiseanbot vorbehalten hat, Kamikaze Travel den Reisenden vor
          Abschluss des Pauschalreisevertrages klar, verständlich und deutlich
          über die Änderungen informiert und die Änderungen im Einvernehmen
          zwischen Reisenden und Kamikaze Travel vorgenommen werden (vgl. § 5
          Abs 1 PRG).
        </p>
        <p>
          2.3. Kamikaze Travel berät und informiert den Reisenden auf Grundlage
          der vom Reisenden mitgeteilten Angaben. Kamikaze Travel stellt die vom
          Reisenden angefragte Pauschalreise unter Rücksichtnahme auf die
          landesüblichen Gegebenheiten des jeweiligen
          Bestimmungslandes/Bestimmungsortes sowie unter Rücksichtnahme auf die
          mit der Pauschalreise allenfalls verbundenen Besonderheiten (z.B.
          Expeditionsreisen) nach bestem Wissen dar. Zu berücksichtigen ist,
          dass es sich bei den von Kamikaze Travel angebotenen Pauschalreisen um
          Reisen handelt, die einerseits körperliche Anforderungen an die
          Reisenden stellen, andererseits aufgrund der Durchführung
          witterungsabhängig sind und es daher unter Rücksicht der Eigenarten
          des jeweiligen Landes zu Änderungen des Reiseverlaufs kommen kann.
          Eine Pflicht zur Information über allgemein bekannte Gegebenheiten
          (z.B. Topographie, Klima, Flora und Fauna der vom Reisenden
          gewünschten Destination etc.) besteht nicht, sofern, je nach Art der
          Pauschalreise, keine Umstände vorliegen, die einer gesonderten
          Aufklärung bedürfen oder sofern nicht die Aufklärung über
          Gegebenheiten für die Erbringung und den Ablauf bzw. die Durchführung
          der zu vereinbarenden Leistungen erforderlich ist. Grundsätzlich ist
          zu berücksichtigen, dass sich der Reisende bewusst für eine andere
          Umgebung entscheidet und der Standard, die Ausstattung, die Speisen
          (insbesondere Gewürze) sowie Hygiene sich an den jeweiligen für das
          Bestimmungsland/den Bestimmungsort üblichen regionalen
          Standards/Kriterien orientieren.
        </p>
        <p>
          2.5. Der Reiseveranstalter informiert den Reisenden gemäß § 4 PRG,
          bevor dieser durch eine Vertragserklärung an einen
          Pauschalreisevertrag gebunden ist:
        </p>
        <p>
          2.5.1. Über das Vorliegen einer Pauschalreise mittels
          Standardinformationsblatt gemäß § 4 Abs 1 PRG.
        </p>
        <p>
          2.5.2. Über die in § 4 Abs 1 PRG angeführten Informationen, sofern
          diese für die zu vereinbarende Pauschalreise einschlägig und für die
          Durchführung und Leistungserbringung erforderlich sind (z.B. Ausübung,
          Kondition, Anforderung etc. erforderlich, sofern diese nicht Teil der
          vereinbarten Leistungen sind). Darüber hinaus können diese
          Informationen grundsätzlich auf der Homepage eingesehen werden.
        </p>
        <p>
          2.5.3. Ob die zu vereinbarende Pauschalreise im Allgemeinen für
          Personen mit eingeschränkter Mobilität geeignet ist (vgl 1.6.), sofern
          diese Information für die betreffende Pauschalreise einschlägig ist (§
          4 Abs 1 Z 1 lit h PRG).
        </p>
        <p>
          2.5.4. Über allgemeine Pass- und Visumserfordernisse des
          Bestimmungslandes einschließlich der ungefähren Fristen für die
          Erlangung von Visa und für die Abwicklung von gesundheitspolizeilichen
          Formalitäten (§ 4 Abs 1 Z 6 PRG), sofern diese Informationen für die
          betreffende Pauschalreise einschlägig sind. Auf Nachfrage informiert
          der Reiseveranstalter über Devisen- und Zollvorschriften. Darüber
          hinaus können allgemeine Informationen zu Pass- und
          Visumserfordernissen, zu gesundheitspolizeilichen Formalitäten sowie
          zu Devisen- und Zollvorschriften von Reisenden mit österreichischer
          Staatsbürgerschaft durch Auswahl des gewünschten Bestimmungslandes
          unter
          https://www.bmeia.gv.at/reise-aufenthalt/reiseinformation/laender/ -
          bzw. von EU-Bürgern von ihren jeweiligen Vertretungsbehörden -
          eingeholt werden. Als bekannt wird vorausgesetzt, dass für Reisen ins
          Ausland in der Regel ein gültiger Reisepass (z.B. nicht abgelaufen,
          nicht als gestohlen oder verloren gemeldet etc.) erforderlich ist, für
          dessen Gültigkeit der Reisende selbst verantwortlich ist. Der Reisende
          ist für die Einhaltung der ihm mitgeteilten gesundheitspolizeilichen
          Formalitäten selbst verantwortlich. Für die Erlangung eines
          notwendigen Visums ist der Reisende, sofern sich nicht der
          Reiseveranstalter oder Reisevermittler bereit erklärt hat, die
          Besorgung eines solchen zu übernehmen, selbst verantwortlich.
        </p>
        <p>
          2.6. Der Reiseveranstalter informiert den Reisenden gemäß Art 11 VO
          2111/05 über die Identität der ausführenden Fluggesellschaft, sofern
          diese bereits bei Vertragsabschluss feststeht. Steht bei
          Vertragsabschluss die ausführende Fluggesellschaft noch nicht fest,
          informiert der Reiseveranstalter den Reisenden über jene
          Fluggesellschaft, die voraussichtlich den Flug durchführen wird.
          Sobald die ausführende Fluggesellschaft feststeht oder wenn es nach
          der Buchung zu einem Wechsel der ausführenden Fluggesellschaft kommt,
          wird der Reisende so rasch wie möglich informiert.
        </p>
        <p>
          2.7. Besondere Wünsche des Reisenden im Sinne von Kundenwünschen (z.B.
          Meerblick), sind grundsätzlich unverbindlich und lösen keinen
          Rechtsanspruch aus, solange diese Wünsche nicht vom Reiseveranstalter
          im Sinne einer Vorgabe des Reisenden gemäß § 6 Abs 2 Z 1 PRG bestätigt
          worden sind. Erfolgt eine Bestätigung, liegt eine verbindliche
          Leistungszusage vor.
        </p>
        <p>
          2.8. Die Aufnahme von Kundenwünschen durch den Reiseveranstalter
          stellt lediglich eine Verwendungszusage dar, diese an den konkreten
          Leistungsträger weiterzuleiten bzw. ihre Erfüllbarkeit abzuklären und
          ist keine rechtlich verbindliche Zusage, solange sie nicht vom
          Reiseveranstalter bestätigt wurde.
        </p>
        <p>
          2.9. Bucht der Reisende nicht direkt beim Reiseveranstalter (z.B.
          durch Besuch in der Filiale, Anfrage per Telefon oder Mail etc.),
          sondern über einen Reisevermittler gelten für diesen die Bestimmungen
          gemäß Punkt 2. dieser AGB.
        </p>
        <h3>
          3. Befugnisse des Reisevermittlers und vor Ort gebuchte Leistungen
        </h3>
        <p>
          3.1. Für den Fall, dass ein Reisender nicht direkt bei Kamikaze Travel
          bucht, ist folgendes zu beachten: Reisevermittler sind vom
          Reiseveranstalter nicht ermächtigt, abweichende Vereinbarungen zu
          treffen, Auskünfte zu geben oder Zusicherungen zu machen, die den
          vereinbarten Inhalt des Pauschalreisevertrags abändern, über die
          vertraglich zugesagten Leistungen vom Reiseveranstalter hinausgehen
          oder im Widerspruch zum Reiseanbot stehen. Reisekataloge und
          Internetausschreibungen, die nicht vom Reiseveranstalter herausgegeben
          wurden, sind für KaMikaze Travel und dessen Leistungspflicht nicht
          verbindlich, soweit sie nicht durch ausdrückliche Vereinbarung
          zwischen dem Reiseveranstalter und Reisendem zum Gegenstand des
          Reiseanbots oder zum Inhalt der Leistungspflicht vom Reiseveranstalter
          gemacht wurden.
        </p>
        <p>
          3.2. Bei Dritten vom Reiseveranstalter verschiedenen bzw. dem
          Reiseveranstalter nicht zurechenbaren Leistungsträgern gebuchte
          Leistungen vor Ort sind für den Reiseveranstalter und dessen
          Leistungspflicht nicht verbindlich und werden diesem nicht
          zugerechnet, sofern diese Leistungen nicht ausdrücklich vom
          Reiseveranstalter bestätigt/autorisiert wurden (vgl auch 20.5.).
        </p>
        <h3>4. Aufklärungs- und Mitwirkungspflicht des Reisenden</h3>
        <p>
          4.1. Der Reisende hat dem Reiseveranstalter – gegebenenfalls unter
          Zuhilfenahme eines Reisevermittlers, wenn über einen solchen gebucht
          wurde - alle für die Pauschalreise erforderlichen und relevanten
          personenbezogenen (z.B. Geburtsdatum, Staatsangehörigkeit etc.) und
          sachbezogenen Informationen (z.B. geplante Einfuhr/Mitnahme von
          Medikamenten, Prothesen, Tieren etc.) rechtzeitig, vollständig und
          wahrheitsgemäß mitzuteilen. Der Reisende hat den Reiseveranstalter
          über alle in seiner Person oder der von Mitreisenden gelegenen
          Umstände (z.B. Allergien, Nahrungsmittelunverträglichkeit, keine
          Reiseerfahrung etc.) und über seine bzw. die besonderen Bedürfnisse
          seiner Mitreisenden, insbesondere über eine vorliegende eingeschränkte
          Mobilität bzw. den Gesundheitszustand und sonstige Einschränkungen,
          welche für die Erstellung von Reiseanboten bzw. für die Aus- bzw.
          Durchführung einer Pauschalreise mit den zu vereinbarenden Leistungen
          von Relevanz sein können (z.B. bei Wanderreisen etc.), wenn
          erforderlich unter Beibringung eines vollständigen qualifizierten
          Nachweises (z.B. ärztliches Attest), in Kenntnis zu setzen.
        </p>
        <p>
          4.2. Dem Reisenden wird empfohlen, bei Vorliegen einer eingeschränkten
          Mobilität oder anderen Einschränkungen bzw. besonderen Bedürfnissen im
          Sinne des Punkt 4.1. (z.B. Erfordernis spezieller Medikation,
          regelmäßiger medizinischer Behandlungen etc.), die geeignet
          erscheinen, die Reisedurchführung zu beeinträchtigen, vor Buchung mit
          einem Arzt abzuklären, ob die notwendige Reisefähigkeit gegeben ist.
        </p>
        <p>
          4.3. Kommt es erst im Zeitraum zwischen Vertragsabschluss und Antritt
          der Pauschalreise zu einer Einschränkung der Mobilität des Reisenden
          oder ergeben sich in diesem Zeitraum sonstige Einschränkungen im Sinne
          des 4.1. hat der Reisende dem Reiseveranstalter dies unverzüglich –
          wobei die Schriftform aus Beweisgründen empfohlen wird - mitzuteilen,
          damit dieser entscheiden kann, ob der Reisende weiterhin ohne
          Gefährdung der eigenen Person oder der Mitreisenden an der
          Pauschalreise teilnehmen kann, oder ob er zum Ausschluss des Reisenden
          und Vertragsrücktritt berechtigt ist. Kommt der Reisende seiner
          Aufklärungspflicht nicht vollständig bzw. rechtzeitig nach und erklärt
          der Reiseveranstalter den Vertragsrücktritt, steht dem
          Reiseveranstalter ein Anspruch auf Entschädigung gemäß den
          Entschädigungspauschalen zu.
        </p>
        <p>
          4.4. Der Reisende, der für sich oder Dritte (Mitreisende) eine Buchung
          vornimmt, gilt als Auftraggeber und übernimmt analog im Sinne des § 7
          Abs 2 PRG, sofern nicht eine andere Vereinbarung getroffen wird, die
          Verpflichtungen aus dem Vertrag mit dem Reiseveranstalter (z.B.
          Entrichtung des Entgelts; nur der Auftraggeber ist berechtigt den
          Rücktritt vom Vertrag zu erklären etc.) (vgl 1.2.).
        </p>
        <p>
          4.5. Der Reisende ist verpflichtet, sämtliche durch den
          Reiseveranstalter übermittelten Vertragsdokumente (z.B.
          Pauschalreisevertrag, Buchungsbestätigung, Gutscheine, Vouchers) auf
          sachliche Richtigkeit zu seinen Angaben/Daten und auf allfällige
          Abweichungen (Schreibfehler; z.B. Namen, Geburtsdatum) sowie
          Unvollständigkeiten zu überprüfen und im Fall von
          Unrichtigkeiten/Abweichungen/Unvollständigkeiten diese dem
          Reiseveranstalter unverzüglich zur Berichtigung – wobei die
          Schriftform aus Beweisgründen empfohlen wird - mitzuteilen. Einen
          allenfalls dadurch entstehenden Mehraufwand, wenn dieser Mehraufwand
          auf falschen oder unrichtigen Angaben des Reisenden beruht, hat der
          Reisende zu tragen, wobei die Gebühr € pro Person beträgt, zzgl.
          Allfälliger von Leistungsträgern erhobenen Gebühren.
        </p>
        <p>
          4.6. Der Reiseveranstalter trägt im Fall der Unmöglichkeit der
          vertraglich vereinbarten Rückbeförderung des Reisenden aufgrund
          unvermeidbarer und außergewöhnlicher Umstände die Kosten für die
          notwendige Unterbringung für höchstens drei Nächte. Dies gilt nicht
          für Reisende mit eingeschränkter Mobilität (gemäß Artikel 2 Buchstabe
          a der Verordnung (EG) Nr. 1107/2006 über die Rechte von behinderten
          Flugreisenden und Flugreisenden mit eingeschränkter Mobilität) und
          deren Mitreisende, für schwangere Reisende, für unbegleitete
          minderjährige Reisende und für Reisende, die besondere medizinische
          Betreuung benötigen, sofern die genannten Personen ihre besonderen
          Bedürfnisse, die bei Buchung noch nicht bestanden haben oder ihnen
          noch nicht bekannt sein mussten, dem Reiseveranstalter 48 Stunden vor
          Reisebeginn mitteilen (vgl 4.3.).
        </p>
        <p>
          4.7. Der Reisende hat gemäß § 11 Abs 2 PRG jede von ihm wahrgenommene
          Vertragswidrigkeit der vereinbarten Reiseleistungen unverzüglich und
          vollständig, inklusive konkreter Bezeichnung der
          Vertragswidrigkeit/des Mangels, zu melden, damit der Reiseveranstalter
          in die Lage versetzt werden kann, die Vertragswidrigkeit – sofern dies
          je nach Einzelfall möglich oder tunlich ist – unter Berücksichtigung
          der jeweiligen Umstände (z.B. Zeitverschiebung, Unmöglichkeit der
          Kontaktaufnahme bei Expeditionsreise, Vorliegen einer Alternative bzw.
          einer Austausch-/Verbesserungsmöglichkeit etc.) und des allenfalls
          damit einhergehenden Aufwandes (z.B. Ersatzzimmer säubern, Ersatzhotel
          ausfindig machen etc.), vor Ort zu beheben. <br /> Bucht der Reisende
          über einen Reisevermittler und tritt eine Vertragswidrigkeit während
          der Geschäftszeiten des Reisevermittlers auf, hat der Reisende die
          Vertragswidrigkeit diesem zu melden. Es wird dem Reisenden empfohlen,
          sich dabei insbesondere aus Beweisgründen der Schriftform zu bedienen.
          Außerhalb der üblichen Geschäftszeiten hat der Reisende
          Vertragswidrigkeiten dem Vertreter des Reiseveranstalters vor Ort,
          oder, wenn ein solcher nicht vorhanden und/oder nicht vertraglich
          geschuldet ist, direkt dem Reiseveranstalter unter der im
          Pauschalreisevertrag mitgeteilten Notfallnummer zu melden. <br /> Im
          Falle des Unterlassens der Meldung einer Vertragswidrigkeit hat dies,
          wenn Abhilfe vor Ort möglich und eine Meldung auch zumutbar gewesen
          wäre, Auswirkungen auf allfällige gewährleistungsrechtliche Ansprüche
          des Reisenden. Das Unterlassen der Meldung kann gemäß § 12 Abs 2 PRG
          hinsichtlich schadenersatzrechtlicher Ansprüche auch als
          Mitverschulden (§ 1304 ABGB) angerechnet werden. Eine Meldung einer
          Vertragswidrigkeit bewirkt noch keine Leistungszusage des
          Reiseveranstalters.
        </p>
        <p>
          4.8. Der Reisende ist verpflichtet, den im Rahmen des getroffenen
          Pauschalreisevertrages vereinbarten Reisepreis gemäß den
          Zahlungsbestimmungen fristgerecht und vollständig zu bezahlen. Im Fall
          der nicht fristgerechten oder nicht vollständigen Anzahlung oder
          Restzahlung behält sich der Reiseveranstalter nach Mahnung unter
          Setzung einer Nachfrist vor, den Rücktritt vom Vertrag zu erklären und
          unabhängig von der anfallenden Entschädigungspauschale einen
          allenfalls darüber hinausgehenden Schadenersatz anzusprechen.
        </p>
        <p>
          4.9. Der Reisende hat im Fall der Geltendmachung und des Erhalts von
          Zahlungen aus Schadenersatz- oder Preisminderungsansprüchen im Sinne
          des § 12 Abs 5 PRG (z.B. Ausgleichszahlung gemäß Art 7
          FluggastrechteVO) oder im Falle des Erhalts sonstiger Auszahlungen und
          Leistungen von Leistungsträgern oder von Dritten, die auf
          Schadenersatz- oder Preisminderungsansprüche des Reisenden gegen den
          Reiseveranstalter anzurechnen sind (z.B. Auszahlungen des Hotels), den
          Reisevermittler oder Reiseveranstalter von diesem Umstand vollständig
          und wahrheitsgemäß in Kenntnis zu setzen.
        </p>
        <p>
          4.10. Den Reisenden trifft bei Auftreten von Vertragswidrigkeiten
          grundsätzlich eine Schadensminderungspflicht (§ 1304 ABGB).
        </p>
        <h3>5. Versicherung</h3>
        <p>
          5.1. Grundsätzlich ist bei Urlaubsreisen zu beachten, dass keine
          wertvollen Gegenstände, wichtige Dokumente etc. mitgenommen werden
          sollten. Bei wichtigen Dokumenten wird die Anfertigung und Verwendung
          von Kopien – soweit deren Gebrauch erlaubt ist - empfohlen. Der
          Diebstahl von Wertgegenständen kann nicht ausgeschlossen werden und
          ist vom Reisenden grundsätzlich selbst, als Verwirklichung des
          allgemeinen Lebensrisikos, zu tragen.
        </p>
        <p>
          5.2. Es wird empfohlen, eine Versicherung
          (Reiserücktrittsversicherung, Reiseabbruchversicherung,
          Reisegepäckversicherung, Reisehaftpflichtversicherung,
          Auslandsreisekrankenversicherung, Verspätungsschutz, Personenschutz
          etc.), welche ausreichende Deckung ab dem Datum des
          Pauschalreisevertrages bis zum Ende der Pauschalreise gewährleistet,
          abzuschließen.
        </p>
        <h3>6. Umbuchung</h3>
        <p>
          6.1. Bei KaMikaze Travel Eigenreisen (Reiseveranstalter ist das
          Kamikaze Travel e.U.) ist eine Umbuchung bis zum 31. Tag vor
          Reiseantritt möglich. Spätere Buchungsänderungen können nur mehr im
          Zuge einer Stornierung der bestehenden Buchung und einer Neubuchung
          vorgenommen werden. Bei Umbuchung einer von KaMikaze Travel
          veranstalteten Reise auf eine andere bereits von KaMikaze Travel
          veröffentlichten Eigenreise oder einen anderen Termin der gleichen
          Reise (Preistoleranz bis 10% des ursprünglichen Reisepreises)
          verrechnet die KaMikaze Travel eine einmalige Bearbeitungsgebühr von
          mindestens € 50,– pro Person. Fallen bei der Umbuchung zusätzliche
          Kosten bei Leistungsträgern (z.B. bei Fluggesellschaften für nicht
          erstattbare Flugtickets, bei Kartenvermittlern für nicht erstattbare
          Eintrittskarten oder bei anderen Leistungsträgern für nicht kostenfrei
          stornierbare Leistungen) an, werden dem Kunden die effektiv
          anfallenden Kosten zusätzlich zur Umbuchungsgebühr in Rechnung
          gestellt.
        </p>
        <p>
          6.2. Bei Umbuchungen von KaMikaze Travel vermittelten Reisen gelten
          die Umbuchungsbedingungen des vermittelten Leistungsträgers.
          Zusätzlich erhebt KaMikaze Travel eine Bearbeitungsgebühr von € 50,–
          pro Buchung.
        </p>
        <h3>7. Buchung/Vertragsabschluss/Anzahlung</h3>
        <p>
          7.1. Der Pauschalreisevertrag kommt zwischen dem Reisenden und
          Kamikaze Travel zustande, wenn Übereinstimmung über die wesentlichen
          Vertragsbestandteile (Preis, Leistung und Termin) besteht und der
          Reisende das Anbot des Reiseveranstalters annimmt.
        </p>
        <p>
          7.1.1. Direktbuchung: Der Reisende kann direkt auf der Website von
          Kamikaze Travel eine Reise anfragen. Der Reisevertrag kommt mit
          Übermittlung der Buchungsbestätigung zustande.
        </p>
        <p>
          7.1.2. Prüfung Verfügbarkeit: Muss Kamikaze Travel aufgrund der
          Anfrage des Reisenden eine Verfügbarkeit etc. überprüfen, so erhält
          der Reisende idF einen für 24 Stunden gültigen Reisevorschlag. Der
          Reisende kann dann auf BKaMikaze Travels dieses Reisevorschlages diese
          Reise buchen (Anbot). Der Reisevertrag kommt auch in diesem Fall mit
          Übermittlung der Buchungsbestätigung (Annahme) zustande. Dadurch
          ergeben sich Rechte und Pflichten für den Reiseveranstalter und für
          den Reisenden.
        </p>
        <p>
          7.2. Der Reisende hat – sofern keine andere Vereinbarung getroffen
          wird – sofort nach Zugang des Pauschalreisevertrages, frühestens
          jedoch 11 Monate vor dem Ende der Pauschalreise, eine Anzahlung von
          20% des Reisepreises auf das im Pauschalreisevertrag genannte Konto
          (oder auf das vom Reisevermittler bekanntgegebene Konto) zu
          überweisen.{" "}
        </p>
        <p>
          7.3. Erfolgt ein Vertragsschluss innerhalb von 20 Tagen vor Abreise,
          ist der gesamte Reisepreis bei Zugang der Reservierungsbestätigung auf
          das dort genannte Konto (oder auf das vom Reisevermittler
          bekanntgegebene Konto) sofort zu überweisen.
        </p>
        <p>
          7.4. Kommt der Reisende seinen Zahlungsverpflichtungen gemäß 7.2. oder
          7.3. nicht nach, behält sich der Reiseveranstalter nach Mahnung mit
          Fristsetzung vor, den Rücktritt vom Vertrag zu erklären und
          Schadenersatz entsprechend den Entschädigungspauschalen zu verlangen.
        </p>
        <h3>8. Pauschalreisevertrag</h3>
        <p>
          8.1. Der Reisende erhält bei Abschluss eines Pauschalreisevertrages
          oder unverzüglich danach eine Ausfertigung des Vertragsdokuments oder
          eine Bestätigung des Vertrags auf einem dauerhaften Datenträger (z.B.
          Papier, E-Mail). Wird der Pauschalreisevertrag in gleichzeitiger
          Anwesenheit der Vertragsparteien geschlossen, hat der Reisende
          Anspruch auf eine Papierfassung. Bei außerhalb von Geschäftsräumen
          geschlossenen Verträgen im Sinne des § 3 Z 1 FAGG stimmt der Reisenden
          zu, die Ausfertigung oder Bestätigung des Pauschalreisevertrages
          alternativ auch auf einem anderen dauerhaften Datenträger (z.B.
          E-Mail) zur Verfügung gestellt zu bekommen.
        </p>
        <p>
          8.2. Dem Reisenden werden an der zuletzt von ihm bekanntgegebenen
          Zustell-/Kontaktadresse (auch E-Mail) rechtzeitig vor Beginn der
          Pauschalreise, sofern nichts anderes vereinbart wurde, die
          Buchungsbelege, Gutscheine, Beförderungsausweise und Eintrittskarten,
          Informationen zu den geplanten voraussichtlichen Abreisezeiten und
          gegebenenfalls zu planmäßigen Zwischenstationen, Anschlussverbindungen
          und Ankunftszeiten zur Verfügung gestellt. Sollten die soeben
          genannten Dokumente/Unterlagen
          Unrichtigkeiten/Abweichungen/Unvollständigkeiten im Sinne von 4.5.
          aufweisen, hat der Reisende den Reisevermittler oder Reiseveranstalter
          zu kontaktieren (vgl 4.5.).
        </p>
        <h3>9. Ersatzperson</h3>
        <p>
          9.1. Der Reisende hat gemäß § 7 PRG das Recht, den
          Pauschalreisevertrag auf eine andere Person, die sämtliche
          Vertragsbedingungen erfüllt und auch für die Pauschalreise geeignet
          ist (Kriterien können z.B. das Geschlecht, das (Nicht)vorliegen einer
          Schwangerschaft, der Gesundheitszustand, erforderliche
          Impfungen/ausreichender Impfschutz, besondere Kenntnisse und
          Fähigkeiten, Visa, gültige Einreisedokumente, das Nichtbestehen eines
          Einreiseverbotes etc. sein) zu übertragen. Erfüllt die andere Person
          nicht alle Vertragsbedingungen oder ist sie nicht für die
          Pauschalreise geeignet, kann der Reiseveranstalter der Übertragung des
          Vertrages widersprechen. Der Reiseveranstalter ist innerhalb einer
          angemessenen Frist von 5 Tagen, spätestens jedoch sieben Tage vor
          Reisebeginn auf einem dauerhaften Datenträger (z.B. Papier, E-Mail)
          über die Übertragung des Vertrages in Kenntnis zu setzen. Für die
          Übertragung des Pauschalreisevertrages ist eine
          Mindestmanipulationsgebühr von € 50,- pro Person zu entrichten, sofern
          nicht darüber hinaus Mehrkosten entstehen. Der Reisende, der den
          Pauschalreisevertrag überträgt, und die Person, die in den Vertrag
          eintritt, haften dem Reiseveranstalter als Gesamtschuldner für den
          noch ausstehenden Betrag des Reisepreises und die
          Mindestmanipulationsgebühr, sowie für allenfalls darüber hinaus
          entstehende Mehrkosten.
        </p>
        <p>
          9.2. Viele Fluggesellschaften oder andere Beförderer oder
          Dienstleister behandeln Änderungen des Reisedatums oder des Namens des
          Reisenden als Stornierungen und berechnen diese entsprechend.
          Entstehen dabei Mehrkosten, werden diese dem Reisenden in Rechnung
          gestellt (analog § 7 Abs 2 PRG).
        </p>
        <h3>10. Preisänderungen vor Reisebeginn</h3>
        <p>
          10.1. Der Reiseveranstalter behält sich im Pauschalreisevertrag das
          Recht vor, nach Abschluss des Pauschalreisevertrages bis spätestens 20
          Tage vor Beginn der Pauschalreise Preisänderungen vorzunehmen. Der
          Reiseveranstalter wird den Reisenden an der von ihm zuletzt
          bekanntgegebenen Adresse klar, verständlich und deutlich auf einem
          dauerhaften Datenträger (z.B. Papier, Email) spätestens 20 Tage vor
          Beginn der Pauschalreise über die Preiserhöhung (inklusive Berechnung)
          unter Angabe der Gründe in Kenntnis setzen.
        </p>
        <p>
          10.2. Bei Änderung folgender Kosten nach Vertragsschluss sind
          Preisänderungen zulässig:
          <br /> 1) Kosten für die Personenbeförderung infolge der Kosten für
          Treibstoff oder andere Energiequellen; 2) Höhe der Steuern und
          Abgaben, die für die vertraglich vereinbarten Reiseleistungen zu
          entrichten sind, wie z.B. Aufenthaltsgebühren, Landegebühren, Ein-
          oder Ausschiffungsgebühren in Häfen, entsprechende Gebühren auf
          Flughäfen sowie Gebühren für Dienstleistungen in Häfen oder Flughäfen;{" "}
          <br /> 3) die für die Pauschalreise geltenden Wechselkurse.
          <br />
          Preisänderungen können Preiserhöhungen oder Preissenkungen zur Folge
          haben. Bezüglich 1) entspricht jede Änderung des Reisepreises dem vom
          Leistungsträger für Bus, Bahn oder Flug zusätzlich berechneten Betrag
          bzw. XX % des Reisepreises pro Dollar der Preissteigerung eines
          Barrels Treibstoff (NY-MEX Index), bezüglich 2) entspricht jede
          Änderung des Reisepreises dem vollen Betrag der Gebühren, bezüglich 3)
          entspricht jede Änderung des Reisepreises der Veränderung der
          Wechselkurse. Im Fall von Preissenkungen wird dem Reisenden der Betrag
          der Preissenkung erstattet. Von diesem Betrag kann der
          Reiseveranstalter aber tatsächliche Verwaltungsausgaben abziehen. Auf
          Verlangen des Reisenden belegt der Reiseveranstalter diese
          Verwaltungsausgaben.
        </p>
        <p>
          10.3. Bei einer Erhöhung von mehr als 8 % des Reisepreises (iSd § 8
          PRG) kommt 11.4. zur Anwendung. Der Reisende hat die Wahl, die
          Erhöhung als Vertragsänderung anzunehmen, der Teilnahme an einer
          Ersatzreise – sofern diese angeboten wird - zuzustimmen oder vom
          Vertrag zurückzutreten, ohne zur Zahlung einer Entschädigungspauschale
          verpflichtet zu sein. Bereits geleistete Versicherungsprämien können
          dem Reisenden nicht zurückerstattet werden.
        </p>
        <h3>11. Änderungen der Leistung vor Reisebeginn</h3>
        <p>
          11.1. Der Reiseveranstalter darf vor Reisebeginn unerhebliche
          Leistungsänderungen vornehmen, sofern er sich dieses Recht im Vertrag
          vorbehalten hat. Der Reiseveranstalter bzw. der Reisevermittler, wenn
          die Pauschalreise über einen solchen gebucht wurde, informiert den
          Reisenden klar, verständlich und deutlich auf einem dauerhaften
          Datenträger (z.B. Papier, Email) an der von ihm zuletzt
          bekanntgegebenen Adresse über die Änderungen.
        </p>
        <p>
          11.2. Unerhebliche Änderung sind – wobei dies jeweils im Einzelfall zu
          prüfen ist - geringfügige, sachlich gerechtfertigte Änderungen, die
          den Charakter und/oder die Dauer und/oder den Leistungsinhalt und/oder
          die Qualität der gebuchten Pauschalreise nicht wesentlich verändern.
        </p>
        <p>
          11.3. Bei erheblichen Änderungen kann es sich um eine erhebliche
          Verringerung der Qualität oder des Wertes von Reiseleistungen, zu
          denen der Reiseveranstalter gezwungen ist, handeln, wenn die
          Änderungen wesentliche Eigenschaften der Reiseleistungen betreffen
          und/oder Einfluss auf die Pauschalreise und/oder Reiseabwicklung
          entfalten. Ob eine Änderung bzw. Verringerung der Qualität oder des
          Werts von Reiseleistungen erheblich ist, muss im Einzelfall unter
          Rücksichtnahme auf die Art, die Dauer, den Zweck und Preis der
          Pauschalreise sowie unter Rücksichtnahme auf die Intensität und Dauer
          sowie Ursächlichkeit der Änderung und allenfalls auf die
          Vorwerfbarkeit der Umstände, die zur Änderung geführt haben, beurteilt
          werden.
        </p>
        <p>
          Der Reiseveranstalter wird daher den Reisenden in den eben angeführten
          Fällen über folgende Punkte an der von ihm zuletzt bekanntgegebenen
          Adresse klar, verständlich und deutlich auf einem dauerhaften
          Datenträger (z.B. Papier, Email) informieren:
          <ul>
            <li>
              die Änderungen der Reiseleistungen sowie gegebenenfalls deren
              Auswirkungen auf den Preis der Pauschalreise
            </li>
            <li>
              - die angemessene Frist, innerhalb derer der Reisende den
              Reiseveranstalter über seine Entscheidung in Kenntnis zu setzen
              hat, sowie die Rechtswirkung der Nichtabgabe einer Erklärung
              innerhalb der angemessenen Frist,
            </li>
            <li>
              gegebenenfalls die als Ersatz angebotene Pauschalreise und deren
              Preis.
            </li>
          </ul>
          Dem Reisenden wird empfohlen, sich bei seiner Erklärung der
          Schriftform zu bedienen. Gibt der Reisende innerhalb der Frist keine
          Erklärung ab, so gilt dies als Zustimmung zu den Änderungen.
        </p>
        <h3>12. Reiseroute/Änderungen</h3>
        <p>
          12.1. Aufgrund von beispielsweise (ohne Anspruch auf Vollständigkeit)
          Umwelt- und Wettereinflüssen (z.B. Regen, Schnee, Wind, Lawinen, Muren
          etc.), Naturkatastrophen (z.B. Erdbeben, Überflutungen, Hurrikans,
          Vulkanausbruch etc.), Grenzsperren, staatlichen Anordnungen, Staus,
          Flugzeitenänderungen, Terroranschlägen, Bürgerkriegen, Aufständen,
          Streiks, Verkehrsunfällen, Unterbrechungen der Beförderungslinien,
          Stromausfällen, kurzfristig geänderten Öffnungszeiten usw. kann von
          der beworbenen bzw. vertraglich vereinbarten Route abgewichen werden,
          Stationen der Rundreise verschoben oder vorgezogen werden, geplante
          Besichtigungen ausgelassen oder geändert werden. In diesen Fällen
          bemüht sich KaMikaze Travel gleichwertige Alternativen anzubieten bzw.
          allenfalls entfallene Teile an anderer Stelle nachzuholen sofern
          möglich und sinnvoll
        </p>
        <h3>13. Gewährleistung</h3>
        <p>
          13.1. Liegt eine Vertragswidrigkeit vor, weil eine vereinbarte
          Reiseleistung nicht oder mangelhaft (=vertragswidrig) erbracht wurde,
          behebt der Reiseveranstalter die Vertragswidrigkeit, sofern der
          Reisende oder seine Mitreisenden (z.B. Familienmitglieder) diese nicht
          selbst herbeiführt und/oder seine Mitwirkungspflichten nicht verletzt
          und/oder die Behebung nicht durch den Reisenden vereitelt wird
          und/oder die Behebung nicht unmöglich oder mit unverhältnismäßigen
          Kosten verbunden wäre. Der Reisende hat dem Reiseveranstalter eine
          angemessene Frist für die Behebung der Vertragswidrigkeit zu setzen,
          wobei die Angemessenheit der Frist jeweils im Einzelfall, ausgehend
          von Art/Zweck/Dauer der Pauschalreise, der angezeigten
          Vertragswidrigkeit, dem Zeitpunkt der Meldung (z.B. spätabends etc.),
          sowie den erforderlichen Zeitressourcen, die für Ersatzbeschaffung
          z.B. eines Objektes (Umzug etc.) notwendig sind, zu beurteilen ist.
          Eine Fristsetzung hat gegenüber dem Vertreter des Reiseveranstalters
          vor Ort, oder, wenn ein solcher nicht vorhanden und/oder nicht
          vertraglich geschuldet ist, gegenüber dem Reiseveranstalter unter der
          im Pauschalreisevertrag mitgeteilten Notfallnummer zu erfolgen.
        </p>
        <p>
          13.2. Der Reisende erklärt sich einverstanden, angemessene
          Nutzungsregelungen oder -beschränkungen der Leistungserbringer bei der
          Inanspruchnahme von Reiseleistungen zu beachten und im Falle von
          auftretenden, typischen Krankheitssymptomen den Guide, die Agentur
          oder KaMikaze Travel unverzüglich zu verständigen – dies kann
          persönlich oder per Telefon oder schriftlich erfolgen.
        </p>
        <p>
          13.3. Unterlässt es der Reisende seiner Mitteilungspflicht gemäß Punkt
          4.7. oder seinen Mitwirkungspflichten nachzukommen (z.B. sich ein vom
          Reiseveranstalter angebotenes Ersatzzimmer anzusehen oder seine Koffer
          für einen Zimmerwechsel zu packen etc.) oder setzt er dem
          Reiseveranstalter eine unangemessen kurze Frist zur Behebung der
          Vertragswidrigkeit oder unterstützt er den Reiseveranstalter im Rahmen
          des zumutbaren bei der Behebung der Vertragswidrigkeit nicht oder
          verweigert er rechtsgrundlos, die vom Reiseveranstalter zur Behebung
          der Vertragswidrigkeit angebotenen Ersatzleistungen, hat der Reisende
          die nachteiligen Rechtsfolgen (vgl Punkt 4.7.) zu tragen. Zu
          berücksichtigen ist, dass eine mangelhafte Ausrüstung grundsätzlich in
          die Sphäre des Reisenden fällt. Ebenso ist darauf zu verweisen, dass
          für eine allfällige Behebung die destinationsbedingten, regionalen
          Eigenheiten z.B. ein anderes Zeitgefühl etc., zu berücksichtigen sind.
        </p>
        <p>
          13.4. Behebt der Reiseveranstalter innerhalb der angemessenen Frist
          die Vertragswidrigkeit nicht, kann der Reisende selbst Abhilfe
          schaffen und vom Reiseveranstalter den Ersatz der dafür erforderlichen
          Ausgaben verlangen (vgl § 11 Abs 4 PRG). Es gilt der Grundsatz der
          Schadenminderungspflicht, dh. der entstandene Schaden (z.B. Kosten für
          Ersatzvornahme) ist möglichst gering zu halten, wobei von Dauer, Wert
          und Zweck der Reise auszugehen ist. Darüber hinaus ist von einer
          objektiven Betrachtungsweise der Vertragswidrigkeit auszugehen.
        </p>
        <p>
          13.5. Kann ein erheblicher Teil der vereinbarten Reiseleistungen nicht
          vertragsgemäß erbracht werden, so bietet der Reiseveranstalter dem
          Reisenden ohne Mehrkosten, sofern dies aufgrund der Umstände und
          Verhältnisse (vor Ort) möglich ist (Unmöglichkeit z.B. wenn nur ein
          Hotel in der gebuchten Kategorie vorhanden ist), angemessene andere
          Vorkehrungen (Ersatzleistung) zur Fortsetzung der Pauschalreise an,
          die, soferne möglich, den vertraglich vereinbarten Leistungen
          qualitativ gleichwertig oder höherwertig sind; Gleiches gilt auch
          dann, wenn der Reisende nicht vertragsgemäß an den Ort der Abreise
          zurückbefördert wird. Haben die vom Reiseveranstalter angebotenen
          anderen Vorkehrungen unter Umständen eine gegenüber den vertraglich
          vereinbarten Leistungen geringere Qualität der Pauschalreise zur Folge
          (z.B. Halbpension an Stelle von All-inclusive), so gewährt der
          Reiseveranstalter dem Reisenden eine angemessene Preisminderung. Der
          Reisende kann die vorgeschlagenen anderen Vorkehrungen nur dann
          ablehnen, wenn diese nicht mit den im Pauschalreisevertrag
          vereinbarten Leistungen vergleichbar sind oder die gewährte
          Preisminderung nicht angemessen ist. Im Fall der Ablehnung hat der
          Reisende darzulegen, dass die vom Reiseveranstalter angebotenen
          anderen Vorkehrungen gegenüber den vertraglich vereinbarten Leistungen
          nicht gleichwertig/vergleichbar sind und/oder die angebotene
          Preisminderung nicht ausreichend ist.
        </p>
        <p>
          13.6. Hat die Vertragswidrigkeit erhebliche Auswirkungen im Sinne von
          Punkt 11.3. auf die Durchführung der Pauschalreise und behebt der
          Reiseveranstalter die Vertragswidrigkeit innerhalb einer vom Reisenden
          gesetzten, die Umstände und Vertragswidrigkeiten berücksichtigenden
          angemessenen Frist (vgl 13.1.) nicht, so kann der Reisende, sofern ihm
          die Fortsetzung der Pauschalreise ausgehend von der Maßfigur eines
          durchschnittlichen Reisenden nicht zumutbar ist, ohne Zahlung einer
          Entschädigung vom Pauschalreisevertrag zurücktreten und gegebenenfalls
          gewährleistungs- und schadenersatzrechtliche Ansprüche gemäß § 12 PRG
          erheben. Tritt der Reisende vom Pauschalreisevertrag zurück sollte er
          sich bewusst sein, dass damit ein gewisses Risiko verbunden ist, da
          sowohl die Erheblichkeit der Auswirkungen von Vertragswidrigkeiten als
          auch die Zumutbarkeit der Fortsetzung der Reise im subjektiven
          Einzelfall (von einem Richter) zu beurteilen sind und das Ergebnis
          dieser Beurteilung von der Wahrnehmung des Reisenden abweichen kann.
          Können keine anderen Vorkehrungen nach Punkt 13.4. angeboten werden
          oder lehnt der Reisende die angebotenen anderen Vorkehrungen nach
          Punkt 13.4. ab, stehen dem Reisenden bei vorliegender
          Vertragswidrigkeit gewährleistungs- und schadenersatzrechtliche
          Ansprüche gemäß § 12 PRG auch ohne Beendigung des
          Pauschalreisevertrags zu. Im Fall der Ablehnung hat der Reisende
          darzulegen, dass die vom Reiseveranstalter angebotenen anderen
          Vorkehrungen gegenüber den vertraglich vereinbarten Leistungen nicht
          gleichwertig/vergleichbar sind und/oder die angebotene Preisminderung
          nicht ausreichend ist. Ist die Beförderung von Personen Bestandteil
          der Pauschalreise, so sorgt der Reiseveranstalter in den in diesem
          Absatz genannten Fällen außerdem für die unverzügliche Rückbeförderung
          des Reisenden mit einem gleichwertigen Beförderungsdienst ohne
          Mehrkosten für den Reisenden.
        </p>
        <p>
          13.7. Können Leistungen aufgrund unvermeidbarer und außergewöhnlicher
          Umstände nicht erbracht werden und tritt der Reiseveranstalter dennoch
          nicht von der Pauschalreise zurück (vgl 17.1.), sondern bietet
          Ersatzleistungen an, sind die dadurch allenfalls entstehenden
          Mehrkosten vom Reisenden zu tragen.
        </p>
        <p>
          13.8. Für den Fall, dass unvermeidbare und außergewöhnliche Umstände
          vorliegen und der Reisende das Anbot von KaMikaze Travel infolge
          Abbruchs der Reise auf Rückforderung nicht annimmt, trägt die dadurch
          entstehenden Mehrkosten der Reisende. KaMikaze Travel übernimmt in
          einem solchen Fall nicht mehr die Kosten der Rückbeförderung bzw.
          fällt das Verbleiben in die Risikosphäre des Reisenden.
        </p>
        <h3>
          14. Rücktritt des Reisenden ohne Entrichtung einer
          Entschädigungspauschale
        </h3>
        <p>
          14.1. Der Reisende kann vor Beginn der Pauschalreise – ohne
          Entrichtung einer Entschädigungspauschale – in folgenden Fällen vom
          Pauschalreisevertrag zurücktreten:
        </p>
        <p>
          14.1.1. Wenn am Bestimmungsort oder in dessen unmittelbarer Nähe,
          wobei dies im Einzelfall unter Berücksichtigung des Vertragsinhalts
          und der Ausstrahlung des relevanten Umstands, welcher die Gefahr mit
          sich bringt, zu beurteilen ist, unvermeidbare und außergewöhnliche
          Umstände auftreten, die die Durchführung der Pauschalreise oder die
          Beförderung von Personen an den Bestimmungsort erheblich im Sinne des
          11.3. beeinträchtigen. Tritt der Reisende in diesen Fällen vom Vertrag
          zurück, hat er Anspruch auf die volle Erstattung aller für die
          Pauschalreise getätigten Zahlungen, nicht aber auf eine zusätzliche
          Entschädigung (vgl § 10 Abs 2 PRG).
        </p>
        <p>
          14.1.2. In den Fällen des Punktes 11.4. Der Rücktritt ist gegenüber
          dem Reiseveranstalter – wobei aus Gründen der Beweisbarkeit
          Schriftform empfohlen wird - zu erklären.
        </p>
        <p>
          14.2. Der Reisende kann nach Beginn der Pauschalreise in den Fällen
          des Punktes 13.5. – ohne Entrichtung einer Entschädigungspauschale –
          vom Pauschalreisevertrag zurücktreten.
        </p>
        <h3>
          15. Rücktritt des Reisenden unter Entrichtung einer
          Entschädigungspauschale{" "}
        </h3>
        <p>
          15.1. Der Reisende ist jederzeit berechtigt, gegen Entrichtung einer
          Entschädigungspauschale (Stornogebühr), vom Vertrag zurückzutreten.
          Der Rücktritt ist gegenüber dem Reiseveranstalter schriftlich zu
          erklären. Wenn die Pauschalreise über einen Reisevermittler gebucht
          wurde, kann der Rücktritt auch gegenüber diesem erklärt werden. Dem
          Reisenden wird empfohlen, den Rücktritt auf einem dauerhaften
          Datenträger (z.B. Papier, Email) zu erklären.
        </p>
        <p>
          15.2. Die Entschädigungspauschale steht in einem prozentuellen
          Verhältnis zum Reisepreis und richtet sich bezüglich der Höhe nach dem
          Zeitpunkt der Rücktrittserklärung sowie nach den erwarteten ersparten
          Aufwendungen und Einnahmen aus anderweitiger Verwendung der
          Reiseleistungen. Im Falle der Unangemessenheit der
          Entschädigungspauschale kann diese vom Gericht gemäßigt werden.
        </p>
        <p>
          15.3. Je nach Pauschalreiseart ergeben sich pro Person folgende
          Entschädigungspauschalen:
          <ul>
            <li>ab dem 30. Tag vor Reiseantritt 20%</li>
            <li>ab dem 10. Tag vor Reiseantritt 70%</li>
            <li>
              ab dem 2. Tag vor Reiseantritt bis zum Tag des Reiseantritts oder
              bei Nichtantritt der Reise 100%
            </li>
          </ul>
          Bitte beachten Sie darüber hinaus, dass für einzelne
          Angebote/Leistungen abweichende Stornobedingungen gelten. Diese werden
          bereits im Rahmen der Angebotsstellung und Reisebestätigung gesondert
          gekennzeichnet. Bei vermittelten Reisen gelten die
          Geschäftsbedingungen des jeweiligen Reiseveranstalters (z.B. TUI
          Deutschland GmbH etc.) bzw. des jeweiligen Leistungsträgers (z.B.
          Airline).
        </p>
        <h3>No-show</h3>
        <p>
          16.1. No-show liegt vor, wenn der Reisende der Abreise fernbleibt,
          weil es ihm am Reisewillen mangelt oder wenn er die Abreise wegen
          einer ihm zurechenbaren Handlung oder wegen eines ihm widerfahrenen
          Zufalls versäumt. Ist weiters klargestellt, dass der Reisende die
          verbleibenden Reiseleistungen nicht mehr in Anspruch nehmen kann oder
          will, hat er folgende Entschädigungspauschale zu entrichten: 100% des
          Reisepreises.
        </p>
        <h3>17. Rücktritt des Reiseveranstalters vor Beginn der Reise</h3>
        <p>
          17.1. Der Reiseveranstalter kann vor Beginn der Pauschalreise vom
          Pauschalreisevertrag zurücktreten, wenn er aufgrund unvermeidbarer und
          außergewöhnlicher Umstände an der Erfüllung des Vertrags gehindert ist
          und seine Rücktrittserklärung dem Reisenden an der zuletzt von ihm
          genannten Zustell-/Kontaktadresse unverzüglich, spätestens vor Beginn
          der Pauschalreise zugeht (vgl § 10 Abs 3 lit b PRG).
        </p>
        <p>
          17.2. Der Reiseveranstalter kann vor Beginn der Pauschalreise vom
          Pauschalreisevertrag zurücktreten, wenn sich für die Pauschalreise
          weniger Personen als die im Vertrag angegebene Mindestteilnehmerzahl
          angemeldet haben und die Rücktrittserklärung des Reiseveranstalters
          dem Reisenden an der zuletzt von ihm genannten Zustell-/
          Kontaktadresse innerhalb der im Vertrag festgelegten Frist, spätestens
          jedoch:
          <ul>
            <li>
              a) 20 Tage vor Beginn der Pauschalreise bei Reisen von mehr als
              sechs Tagen,
            </li>
            <li>
              b) sieben Tage vor Beginn der Pauschalreise bei Reisen zwischen
              zwei und sechs Tagen,
            </li>
            <li>
              c) 48 Stunden vor Beginn der Pauschalreise bei Reisen, die weniger
              als zwei Tage dauern,
            </li>
          </ul>
          zugeht (vgl § 10 Abs 3 lit a PRG).
        </p>
        <p>
          17.3. Tritt der Reiseveranstalter gemäß 17.1. oder 17.2. vom
          Pauschalreisevertrag zurück, erstattet er dem Reisenden den
          Reisepreis, er hat jedoch keine zusätzliche Entschädigung zu leisten.
        </p>
        <h3>
          18. Rücktritt des Reiseveranstalters nach Beginn der Pauschalreise
        </h3>
        <p>
          18.1. Der Reiseveranstalter wird von der Vertragserfüllung ohne
          Verpflichtung zur Rückerstattung des Reisepreises befreit, wenn der
          Reisende die Durchführung der Pauschalreise durch grob ungebührliches
          Verhalten (wie z.B. Alkohol, Drogen, Nichteinhalten eines
          Rauchverbotes, Missachten bestimmter Bekleidungsvorschriften z.B. beim
          Besuch religiöser Stätten oder bei der Einnahme von Mahlzeiten,
          strafbares Verhalten, störendes Verhalten gegenüber Mitreisenden,
          Nichteinhalten der Vorgaben des Reiseleiters wie z.B. regelmäßiges
          Zuspätkommen etc.), ungeachtet einer Abmahnung stört, sodass der
          Reiseablauf oder Mitreisende gestört und in einem Ausmaß behindert
          werden, dass geeignet ist, die Urlaubserholung Dritter oder
          Mitreisender zu beinträchtigen oder den Reisezweck zu vereiteln. In
          einem solchen Fall ist der Reisende dem Reiseveranstalter gegenüber
          zum Ersatz des Schadens verpflichtet.
        </p>
        <p>
          18.2. Treten während der Reise außergewöhnliche und unvermeidbare
          Umstände auf, so kann KaMikaze Travel die Reise abbrechen bzw. die
          Reiseroute ändern. Weigert sich der Reisende im Falle des Abbruchs der
          Reise mit KaMikaze Travel zurückzureisen, so verbleibt der Reisende
          auf eigenes Risiko sowie eigene Kosten.
        </p>
        <h3>19. Allgemeines Lebensrisiko des Reisenden</h3>
        <p>
          19.1. Eine Pauschalreise bringt in der Regel eine Veränderung der
          gewohnten Umgebung mit sich. Eine damit einhergehende Verwirklichung
          des allgemeinen Lebensrisikos des Reisenden wie beispielsweise (ohne
          Anspruch auf Vollständigkeit), Stress, Übelkeit (z.B. aufgrund
          klimatischer Veränderungen), Müdigkeit (z.B. aufgrund eines
          feucht-schwülen Klimas), Verdauungsprobleme (z.B. aufgrund ungewohnter
          Gewürze, Speisen etc.) und/oder eine Verwirklichung eines allenfalls
          mit der Reise verbundenen Risikos wie beispielsweise (ohne Anspruch
          auf Vollständigkeit) Ohrenschmerzen bei Tauchreisen, Höhenkrankheit
          bei Reisen in große Höhe, Seekrankheit bei Kreuzfahrten und vieles
          mehr, fallen in die Sphäre des Reisenden und sind dem
          Reiseveranstalter nicht zuzurechnen.
        </p>
        <p>
          19.2. Alle Reisen und Kurse werden von KaMikaze Travel gewissenhaft
          vorbereitet. KaMikaze Travel kann aber keine Garantie für Gipfel oder
          subjektiv vorgestellte Reiseerfolge geben. Vielen der von KaMikaze
          Travel angebotenen Reisen und Kurse haftet ein Hauch von Abenteuer,
          Risiko und Ungewissheit an. Daran sollten die Reisenden aber vor der
          Buchung denken und mit diesem Bewusstsein teilnehmen. KaMikaze Travel
          ist sicher, dass die Reisenden dann die gebuchte Reise in bester
          Erinnerung behalten. Bei sämtlichen Kursen, Führungen, Trekkings und
          Expeditionen ist zu beachten, dass gerade im Bergsport ein erhöhtes
          Unfall- und Verletzungsrisiko besteht (Absturzgefahr, Lawinen,
          Steinschlag, Spaltensturz, Höhenkrankheit, Kälteschäden etc.), das
          auch durch umsichtige und fürsorgliche Betreuung der eingesetzten
          Guides nicht vollkommen reduziert und ausgeschlossen werden kann. Auch
          ist zu beachten, dass im Gebirge, vor allem in abgelegenen Regionen,
          aufgrund technischer oder logistischer Schwierigkeiten nur in sehr
          eingeschränktem Umfang Rettungs- und/oder medizinische
          Behandlungsmöglichkeiten gegeben sein können, sodass auch kleinere
          Verletzungen oder Zwischenfälle schwerwiegende Folgen haben können.
          Hier wird von jedem Teilnehmer ein erhebliches Maß an
          Eigenverantwortung und Umsichtigkeit, eine angemessene eigene
          Tourenvorbereitung, aber auch ein erhöhtes Maß an Risikobereitschaft
          vorausgesetzt. Es wird dem Reisenden deshalb dringend empfohlen, sich
          intensiv (z. B. durch Studium der einschlägigen alpinen Fachliteratur)
          mit den Anforderungen und Risiken auseinanderzusetzen, die mit dem von
          ihm gebuchten Programm verbunden sein können. Bei sämtlichen Reisen
          außerhalb des Alpengebietes erfolgt die Teilnahme im Hinblick auf den
          bergsteigerischen Teil der Reiseveranstaltung auf der Basis als
          selbstständiger Bergsteiger. Je nach Tourenziel (z. B. bei
          Expeditionen und Trekkingtouren) kann dabei die eigentliche
          Bergbesteigung entsprechend der jeweiligen Reiseausschreibung nicht
          Bestandteil der vertraglich vereinbarten Reiseleistung sein. Die
          außeralpinen Reisen von KaMikaze Travel führen häufig in abgelegene
          und wenig erschlossene, zum Teil ausgesprochen wilde Regionen mit
          entsprechend reduzierter Infrastruktur und gelegentlich auch
          schwierigen Wetterbedingungen. Auch in diesen Gebieten müssen aber
          lokale Transportmittel wie z.B. Flugzeuge, Busse, Fähren und/oder
          sonstige Fahrzeuge benutzt werden, die im Einzelfall nicht
          europäischen Sicherheitsmaßstäben entsprechen, für die es aber keine
          Alternativen gibt. Dadurch können sich teilweise erhebliche
          Transportrisiken ergeben, auf die KaMikaze Travel keinen Einfluss hat.
          Auch insoweit muss deshalb der Reisende eine entsprechende
          Risikobereitschaft mitbringen. Sollten Reisende Fragen zum Gefahren-
          und Risikopotenzial einer Reise haben, bitten wir sie, sich vor
          Abschluss des Reisevertrages mit KaMikaze Travel in Verbindung zu
          setzen.
        </p>
        <p>
          19.3. Nimmt der Reisende Leistungen, die ihm ordnungsgemäß angeboten
          wurden, aus den oben genannten Gründen nicht in Anspruch oder erklärt
          er aus einem solchen Grund den Vertragsrücktritt, ist er nicht
          berechtigt, gewährleistungsrechtliche Ansprüche oder Rückforderungen
          von nicht in Anspruch genommenen Teilen von Reiseleistungen geltend zu
          machen.
        </p>
        <h3>Haftung</h3>
        <p>
          20.1. Verletzen der Reiseveranstalter oder ihm zurechenbare
          Leistungsträger schuldhaft die dem Reiseveranstalter aus dem
          Vertragsverhältnis mit dem Reisenden obliegenden Pflichten, so ist
          dieser dem Reisenden zum Ersatz des daraus entstandenen Schadens
          verpflichtet.
        </p>
        <p>
          20.2. Der Reiseveranstalter haftet nicht für Personen-, Sach- und
          Vermögensschäden des Reisenden die im Zusammenhang mit gebuchten
          Leistungen entstehen, sofern sie
        </p>
        <p>
          20.2.1. eine Verwirklichung des allgemeinen Lebensrisikos des
          Reisenden oder eines allenfalls mit der Pauschalreise verbundenen
          allgemeinen Risikos, welches in die Sphäre des Reisenden fällt,
          darstellen (vgl 19.)
        </p>
        <p>20.2.2. dem Verschulden des Reisenden zuzurechnen sind;</p>
        <p>
          20.2.3. einem Dritten zuzurechnen sind, der an der Erbringung der vom
          Pauschalreisevertrag umfassten Reiseleistungen nicht beteiligt ist,
          und die Vertragswidrigkeit weder vorhersehbar noch vermeidbar war;
          oder
        </p>
        <p>
          20.2.4. auf unvermeidbare und außergewöhnliche Umstände zurückzuführen
          sind.
        </p>
        <p>
          20.3. Bei Reisen mit besonderen Risken (z.B. Expeditionscharakter)
          haftet der Reiseveranstalter nicht für die Folgen, die sich im Zuge
          der Verwirklichung der Risken ergeben, wenn dies außerhalb seines
          Pflichtenbereiches geschieht. Unberührt bleibt die Verpflichtung des
          Reiseveranstalters, die Pauschalreise sorgfältig vorzubereiten und die
          mit der Erbringung der einzelnen Reiseleistungen beauftragten Personen
          und Unternehmen sorgfältig auszuwählen.
        </p>
        <p>
          20.4. Der Reisende hat Gesetzen und Vorschriften, sowie Anweisungen
          und Anordnungen des Guides bzw. des Personals vor Ort, sowie Geboten
          und Verboten (z.B. Kletterverbote durch naturschutzbedingte
          Einschränkungen bzw. Warnhinweisen, Badeverbot, Tauchverbot etc.)
          Folge zu leisten. Bei Nichtbefolgen durch den Reisenden haftet der
          Reiseveranstalter nicht für allenfalls daraus entstehende Personen-
          und Sachschäden des Reisenden oder Personen- und Sachschäden Dritter.
        </p>
        <p>
          20.5. Der Reisende hat Gesetzen und Vorschriften, Anweisungen und
          Anordnungen des Personals vor Ort, sowie Geboten und Verboten (z.B.
          Badeverbot, Tauchverbot etc.) Folge zu leisten. Bei Nichtbefolgen
          durch den Reisenden haftet der Reiseveranstalter nicht für allenfalls
          daraus entstehende Personen- und Sachschäden des Reisenden oder
          Personen- und Sachschäden Dritter.
        </p>
        <p>
          20.6. Der Reiseveranstalter haftet nicht für die Erbringung einer
          Leistung, welche nicht von ihm zugesagt worden ist bzw. welche vom
          Reisenden nach Reiseantritt selbst vor Ort bei Dritten bzw. dem
          Reiseveranstalter nicht zurechenbaren Leistungsträgern zusätzlich
          gebucht worden ist.
        </p>
        <p>
          20.7. Dem Reisenden wird empfohlen, keine Gegenstände besonderen Werts
          mitzunehmen. Weiters wird empfohlen, die mitgenommenen Gegenstände
          ordnungsgemäß zu verwahren bzw. zu versichern (vgl 5.1.).
        </p>
        <p>
          20.8. Soweit das Montrealer Übereinkommen über die Beförderung im
          internationalen Luftverkehr 2001, das Athener Protokoll 2002 zum
          Athener Übereinkommen über die Beförderung auf See 1974 oder das
          Übereinkommen über den internationalen Eisenbahnverkehr 1980 idF 1999
          den Umfang des Schadenersatzes oder die Bedingungen, unter denen ein
          Erbringer einer vom Pauschalreisevertrag umfassten Reiseleistung
          Schadenersatz zu leisten hat, einschränken, gelten diese
          Einschränkungen auch für den Reiseveranstalter (vgl § 12 Abs 4 PRG).
        </p>
        <h3>21. Geltendmachung von Ansprüchen</h3>
        <p>
          21.1. Um die Geltendmachung und Verifizierung von behaupteten
          Ansprüchen zu erleichtern, wird dem Reisenden empfohlen, sich über die
          Nichterbringung oder mangelhafte Erbringung von Leistungen
          schriftliche Bestätigungen geben zu lassen bzw. Belege, Beweise,
          Zeugenaussagen zu sichern.
        </p>
        <p>
          21.2. Gewährleistungsansprüche können innerhalb von 2 Jahren geltend
          gemacht werden. Schadenersatzansprüche verjähren nach 3 Jahren.
        </p>
        <p>
          21.3. Es empfiehlt sich, im Interesse des Reisenden, Ansprüche
          unverzüglich nach Rückkehr von der Pauschalreise vollständig und
          konkret bezeichnet direkt beim Reiseveranstalter oder im Wege des
          Reisevermittlers geltend zu machen, da mit zunehmender Verzögerung mit
          Beweisschwierigkeiten zu rechnen ist.
        </p>
        <h3>22. Zustellung - elektronischer Schriftverkehr</h3>
        <p>
          22.1. Als Zustell-/ Kontaktadresse des Reisenden gilt die dem
          Reiseveranstalter zuletzt bekannt gegebene Adresse (z.B.
          Email-Adresse). Änderungen sind vom Reisenden unverzüglich
          bekanntzugeben. Es wird dem Reisenden empfohlen, sich dabei der
          Schriftform zu bedienen.
        </p>
        <h3>23. Auskunftserteilung an Dritte</h3>
        <p>
          23.1. Auskünfte über die Namen der Reiseteilnehmer und die
          Aufenthaltsorte von Reisenden werden an dritte Personen auch in
          dringenden Fällen nicht erteilt, es sei denn, der Reisende hat eine
          Auskunftserteilung ausdrücklich gewünscht und der Berechtigte wird bei
          Buchung bekannt gegeben. Die durch die Übermittlung dringender
          Nachrichten entstehenden Kosten gehen zu Lasten des Reisenden. Es wird
          daher den Reisenden empfohlen, ihren Angehörigen die genaue
          Urlaubsanschrift bekanntzugeben.
        </p>
        <h3>24. Reiseinsolvenzversicherung </h3>
        <p></p>
        <h3>Allgemeines</h3>
        <p>
          Erfüllungsort ist Saalbach-Hinterglemm/Österreich. Es gilt das
          österreichische Recht und Ausschluss der Kollisionsnormen. Alle
          Angaben entsprechen dem Stand Oktober 2024. Sollte eine der
          obenstehenden Bestimmungen ungültig sein, so wird hierdurch die
          Gültigkeit der restlichen Bestimmungen nicht berührt. Die ungültige
          Bestimmung wird durch eine solche gültige oder wirksame ersetzt, die
          dem wirtschaftlichen Zweck der ungültigen Bestimmung am weitesten
          entspricht. Stand: Oktober 2024
        </p>
      </StaticPageLayout>

      <StaticPageLayout className="terms-layout" title={headline2}>
        <h3 id="section-headline2">1. Geltungsbereich</h3>

        <p>
          1.1. Der Reisevermittler vermittelt Reiseverträge über einzelne
          Reiseleistungen (wie z.B. Flug, Hotel etc.), über Pauschalreisen (iSd
          § 2 Abs 2 PRG) sowie über verbundene Reiseleistungen (iSd § 2 Abs 5
          PRG) zwischen Reiseveranstalter bzw. Leistungsträger einerseits und
          dem Reisenden andererseits. Der Reisevermittler erbringt seine
          Leistungen entsprechend den gesetzlichen Bestimmungen, insbesondere
          dem Pauschalreisegesetz (PRG), sowie der Pauschalreiseverordnung (PRV)
          mit der Sorgfalt eines ordentlichen Unternehmers. Im nachfolgenden
          meint Reisevermittler das Unternehmen Kamikaze Travel e.U.
        </p>

        <p>
          1.2. Die Allgemeinen Geschäftsbedingungen gelten als vereinbart, wenn
          sie - bevor der Reisende durch eine Vertragserklärung an einen Vertrag
          gebunden ist - übermittelt wurden oder der Reisende deren Inhalt
          einsehen konnte. Sie sind Grundlage des zwischen Reisevermittler und
          Reisenden abgeschlossenen Geschäftsbesorgungsvertrag
        </p>

        <p>
          1.3. Für den Geschäftsbesorgungsvertrag gelten die gegenständlichen
          Allgemeinen Geschäftsbedingungen. Für Vertragsverhältnisse zwischen
          dem Reisenden und dem vermittelten Reiseveranstalter, den vermittelten
          Transportunternehmen (z.B. Bahn, Bus, Flugzeug u. Schiff etc.) und
          anderen vermittelten Leistungsträgern, gelten die jeweiligen
          allgemeinen Geschäftsbedingungen, sofern sie dem Reisenden - bevor er
          durch eine Vertragserklärung an einen Vertrag gebunden ist –
          übermittelt wurden oder der Reisende deren Inhalt einsehen konnte und
          der Inhalt der Geschäftsbedingungen nicht rechtswidrig ist oder gegen
          bestehendes Recht verstößt.
        </p>

        <h3>2. Aufgaben des Reisevermittlers</h3>

        <p>
          2.1. Ausgehend von den Angaben des Reisenden erstellt der
          Reisevermittler für den Reisenden Reisevorschläge. Diese sind
          unverbindlich, es handelt sich deshalb noch nicht um Anbote iSd § 4
          PRG. Können aufgrund der Angaben des Reisenden keine Reisevorschläge
          erstellt werden, so weist der Reisevermittler den Reisenden darauf
          hin. Die Reisevorschläge basieren auf den Angaben des Reisenden,
          weshalb unrichtige und/oder unvollständige Angaben durch den Reisenden
          - mangels Aufklärung durch den Reisenden - Grundlage der
          Reisevorschläge sein können. Bei der Erstellung von Reisevorschlägen
          können beispielsweise (ohne Anspruch auf Vollständigkeit), die Höhe
          des Preises, Fachkompetenzen des Reiseveranstalters/Leistungsträgers,
          Rabatte, das Bestpreisprinzip und anderes mehr allenfalls als
          Parameter herangezogen werden.
        </p>

        <p>
          2.2. Hat der Reisende ein konkretes Interesse an einem der vom
          Reisevermittler ihm unterbreiteten Reisevorschläge, dann erstellt der
          Reisevermittler auf Basis des Reisevorschlages ein Reiseanbot im Namen
          des Reiseveranstalters gemäß den Vorgaben des § 4 PRG, soweit diese
          für die Reise von Relevanz sind. Das vom Reisevermittler erstellte
          Reiseanbot bindet den Reiseveranstalter bzw. bei verbundenen
          Reiseleistungen oder einzelnen Reiseleistungen den Leistungsträger.
          Ein Vertrag zwischen Reiseveranstalter bzw. bei verbundenen
          Reiseleistungen oder einzelnen Reiseleistungen zwischen
          Leistungsträger und Reisendem kommt zustande, wenn das Reiseanbot
          durch den Reisenden angenommen wird (=Vertragserklärung des
          Reisenden).
        </p>

        <p>
          2.3. Der Reisevermittler berät und informiert den Reisenden auf
          Grundlage der vom Reisendem dem Reisevermittler mitgeteilten Angaben.
          Der Reisevermittler stellt die dem Reisenden nach dessen Angaben zu
          vermittelnde Pauschalreise des Reiseveranstalters oder bei verbundenen
          Reiseleistungen oder bei einzelnen Reiseleistungen die Leistung des
          Leistungsträgers unter Rücksichtnahme auf die landesüblichen
          Gegebenheiten des jeweiligen Bestimmungslandes/Bestimmungsortes sowie
          unter Rücksichtnahme auf die mit der Reise allenfalls verbundenen
          Besonderheiten (z.B. Expeditionsreisen) nach besten Wissen dar. Eine
          Pflicht zur Information über allgemein bekannte Gegebenheiten (z.B.
          Topographie, Klima, Flora und Fauna der vom Reisenden gewünschten
          Destination) besteht nicht, sofern je nach Art der Reise keine
          Umstände vorliegen, die einer gesonderten Aufklärung bedürfen oder
          sofern nicht die Aufklärung über Gegebenheiten für die Erbringung und
          den Ablauf bzw. die Durchführung der zu vermittelnden Leistung
          erforderlich ist. Grundsätzlich ist zu berücksichtigen, dass sich der
          Reisende bewusst für eine andere Umgebung entscheidet, und der
          Standard, die Ausstattung, die Speisen (insbesondere Gewürze) sowie
          Hygiene sich an den jeweiligen für das Bestimmungsland/den
          Bestimmungsort üblichen regionalen Standards/Kriterien orientieren.
          Darüber hinaus hat der Reisende die Möglichkeit nähere Angaben zu den
          landesüblichen Gegebenheiten insbesondere in Hinblick auf Lage, Ort
          und Standard (Landesüblichkeit) der zu vermittelnden Leistungen
          grundsätzlich im Katalog oder auf der Website des jeweiligen
          Reiseveranstalters nachzulesen.
        </p>

        <p>
          2.4. Der Reisevermittler informiert den Reisenden gemäß § 4 PRG, bevor
          dieser durch eine Vertragserklärung an einen Pauschalreisevertrag
          gebunden ist: 2.4.1. Über das Vorliegen einer Pauschalreise mittels
          Standardinformationsblatt gemäß § 4 Abs 1 PRG.
        </p>

        <p>
          2.4.2. Über die in § 4 Abs 1 PRG angeführten Informationen, sofern
          diese für die zu vermittelnde Pauschalreise einschlägig und für die
          Durchführung und Leistungserbringung erforderlich sind (z.B. sind bei
          einem reinen Badeurlaub keine Hinweise auf Besichtigungen wie bei
          Studienreisen etc. erforderlich, sofern diese nicht Teil der
          vereinbarten Leistungen sind). Darüber hinaus können diese
          Informationen grundsätzlich – sofern vorhanden – im Katalog oder auf
          der Homepage des jeweiligen Reiseveranstalters eingesehen werden.
        </p>

        <p>
          2.4.3. Ob die dem Reisenden zu vermittelnde Pauschalreise im
          Allgemeinen für Personen mit eingeschränkter Mobilität geeignet ist,
          sofern diese Information für die betreffende Pauschalreise einschlägig
          ist (§ 4 Abs 1 Z 1 lit h PRG). Eine Person mit eingeschränkter
          Mobilität ist analog zu Art 2 lit a VO 1107/2006 (Rechte von
          behinderten Flugreisenden und Flugreisenden mit eingeschränkter
          Mobilität) eine Person mit einer körperlichen Behinderung (sensorisch
          oder motorisch, dauerhaft oder zeitweilig), die die Inanspruchnahme
          von Bestandteilen der Pauschalreise (z.B. Benutzung eines
          Beförderungsmittels, einer Unterbringung) einschränkt und eine
          Anpassung der zu vermittelnden Leistungen an die besonderen
          Bedürfnisse dieser Person erfordert.
        </p>

        <p>
          2.4.4. Über allgemeine Pass- und Visumserfordernisse des
          Bestimmungslandes einschließlich der ungefähren Fristen für die
          Erlangung von Visa und für die Abwicklung von gesundheitspolizeilichen
          Formalitäten (§ 4 Abs 1 Z 6 PRG), sofern diese Informationen für die
          betreffende Pauschalreise einschlägig sind. Auf Nachfrage informiert
          der Reisevermittler über Devisen- und Zollvorschriften. Darüber hinaus
          können allgemeine Informationen zu Pass- und Visumserfordernissen, zu
          gesundheitspolizeilichen Formalitäten sowie zu Devisen- und
          Zollvorschriften von Reisenden mit österreichischer Staatsbürgerschaft
          durch Auswahl des gewünschten Bestimmungslandes unter
          https://www.bmeia.gv.at/reise-aufenthalt/reiseinformation/laender/ -
          bzw. von EU-Bürgern von ihren jeweiligen Vertretungsbehörden -
          eingeholt werden. Als bekannt wird vorausgesetzt, dass für Reisen ins
          Ausland in der Regel ein gültiger Reisepass (z.B. nicht abgelaufen,
          nicht als gestohlen oder verloren gemeldet etc.) erforderlich ist, für
          dessen Gültigkeit der Reisende selbst verantwortlich ist. Der Reisende
          ist für die Einhaltung der ihm mitgeteilten gesundheitspolizeilichen
          Formalitäten selbst verantwortlich. Für die Erlangung eines
          notwendigen Visums ist der Reisende, sofern sich nicht der
          Reisevermittler bereit erklärt hat, die Besorgung eines solchen zu
          übernehmen, selbst verantwortlich.
        </p>

        <p>
          2.5. Der Reisevermittler informiert den Reisenden, bevor dieser durch
          eine Vertragserklärung gebunden ist, gemäß § 15 Abs 1 PRG bei
          verbundenen Reiseleistungen, dass der Reisende keine Rechte in
          Anspruch nehmen kann, die ausschließlich für Pauschalreisen gelten,
          und dass jeder Leistungserbringer lediglich für die vertragsgemäße
          Erbringung seiner Leistung haftet sowie, dass dem Reisenden der
          Insolvenzschutz nach der Pauschalreiseverordnung, zugutekommt. Der
          Reisevermittler entspricht gemäß § 15 Abs 2 PRG dieser
          Informationspflicht, wenn er das entsprechende
          Standardinformationsblatt gemäß PRG Anhang II bereitstellt, sofern die
          Art der verbundenen Reiseleistungen in einem dieser
          Standardinformationsblätter abgedeckt ist.
        </p>

        <p>
          Besondere Wünsche des Reisenden im Sinne von Kundenwünschen (z.B.
          Meerblick) sind grundsätzlich unverbindlich und lösen keinen
          Rechtsanspruch aus, solange diese Wünsche nicht vom Reiseveranstalter
          bei Pauschalreisen im Sinne einer Vorgabe des Reisenden gemäß § 6 Abs
          2 Z1 PRG bzw. bei verbundenen Reiseleistungen oder einzelnen
          Reiseleistungen im Sinne einer Vorgabe des Reisenden vom
          Leistungsträger bestätigt worden sind. Erfolgt eine Bestätigung, liegt
          eine verbindliche Leistungszusage vor. Die Erklärungen des
          Reisevermittlers stellen eine Verwendungszusage dar, die Wünsche des
          Reisenden an den Reiseveranstalter/konkreten Leistungsträger
          weiterzuleiten und sind keine rechtlich verbindliche Zusage, solange
          sie nicht vom Reiseveranstalter bzw. bei verbundenen Reiseleistungen
          oder einzelnen Reiseleistungen vom Leistungsträger bestätigt wurden.
        </p>

        <h3>3. Aufklärungs- und Mitwirkungspflicht des Reisenden</h3>

        <p>
          3.1. Der Reisende hat dem Reisevermittler alle für die Reise
          erforderlichen und relevanten personenbezogenen (z.B. Geburtsdatum,
          Staatsangehörigkeit etc.) und sachbezogenen Informationen (z.B.
          geplante Einfuhr/Mitnahme von Medikamenten, Prothesen, Tieren, etc.),
          rechtzeitig, vollständig und wahrheitsgemäß mitzuteilen. Der Reisende
          hat den Reisevermittler über alle in seiner Person oder der von
          Mitreisenden gelegenen Umstände (z.B. Allergien,
          Nahrungsmittelunverträglichkeit, keine Reiseerfahrung etc.), und über
          seine bzw. die besonderen Bedürfnisse seiner Mitreisenden,
          insbesondere über eine vorliegende eingeschränkte Mobilität bzw. den
          Gesundheitszustand und sonstige Einschränkungen, welche für die
          Erstellung von Reisevorschlägen/Reiseanboten bzw. für die Aus- bzw.
          Durchführung der Reise und Reiseleistungen von Relevanz sein können
          (z.B. bei Wanderreisen etc.), wenn erforderlich unter Beibringung
          eines vollständigen qualifizierten Nachweises (z.B. ärztliches
          Attest), in Kenntnis zu setzen.
        </p>

        <p>
          3.2. Dem Reisenden wird empfohlen, bei Vorliegen einer eingeschränkten
          Mobilität oder anderen Einschränkungen bzw. besonderen Bedürfnissen im
          Sinne des Punkt 3.1. (z.B. Erfordernis spezieller Medikation,
          regelmäßiger medizinischer Behandlungen etc.), die geeignet
          erscheinen, die Reisedurchführung zu beeinträchtigen, vor Buchung mit
          einem Arzt abzuklären, ob die notwendige Reisefähigkeit gegeben ist.
        </p>

        <p>
          3.3. Kommt es erst im Zeitraum zwischen Vertragsabschluss und Antritt
          der Reise zu einer Einschränkung der Mobilität des Reisenden oder
          ergeben sich in diesem Zeitraum sonstige Einschränkungen im Sinne des
          3.1. hat der Reisende dem Reisevermittler dies unverzüglich – wobei
          die Schriftform aus Beweisgründen empfohlen wird - mitzuteilen, damit
          dieser den Reiseveranstalter bzw. bei verbundenen Reiseleistungen oder
          einzeln Reiseleistungen den Leistungsträger entsprechend informieren
          kann.
        </p>

        <p>
          3.4. Der Reisende, der für sich oder Dritte durch den Reisevermittler
          eine Buchung vornehmen lässt, gilt als Auftraggeber und übernimmt
          analog im Sinne des § 7 Abs 2 PRG, sofern nicht eine andere
          Vereinbarung getroffen wird, die Verpflichtungen aus dem
          Geschäftsbesorgungsvertrag gegenüber dem Reisevermittler (z.B.
          Entrichtung des Entgelts etc.).
        </p>

        <p>
          3.5. Der Reisende ist verpflichtet, sämtliche durch die Vermittlung
          des Reisevermittlers übermittelten Vertragsdokumente (z.B.
          Pauschalreisevertrag, Buchungsbestätigung, Gutscheine, Vouchers) auf
          sachliche Richtigkeit zu seinen Angaben/Daten und auf allfällige
          Abweichungen (Schreibfehler; z.B. Namen, Geburtsdatum) sowie
          Unvollständigkeiten zu überprüfen und im Fall von
          Unrichtigkeiten/Abweichungen/Unvollständigkeiten diese dem
          Reiseveranstalter unverzüglich zur Berichtigung – wobei die
          Schriftform aus Beweisgründen empfohlen wird - mitzuteilen.
        </p>

        <p>
          3.6. Damit für Reisende mit eingeschränkter Mobilität (gemäß Artikel 2
          Buchstabe a der Verordnung (EG) Nr. 1107/2006 über die Rechte von
          behinderten Flugreisenden und Flugreisenden mit eingeschränkter
          Mobilität) und deren Mitreisende, für schwangere Reisende,
          unbegleitete minderjährige Reisende und Reisende, die besondere
          medizinische Betreuung benötigen, die beschränkte
          Kostentragungspflicht des Reiseveranstalters für die notwendige
          Unterbringung im Fall einer aufgrund unvermeidbarer und
          außergewöhnlicher Umstände nicht möglichen Rückbeförderung nicht zur
          Anwendung kommt, haben die betroffenen Reisenden den Reiseveranstalter
          oder Reisevermittler mindestens 48 Stunden vor Reisebeginn über ihre
          besonderen Bedürfnisse in Kenntnis zu setzen.
        </p>

        <p>
          3.7. Der Reisende hat gemäß § 11 Abs 2 PRG, jede von ihm wahrgenommene
          Vertragswidrigkeit der vereinbarten Reiseleistungen unter
          Berücksichtigung der jeweiligen Umstände unverzüglich und vollständig,
          inklusive konkreter Bezeichnung der Vertragswidrigkeit/des Mangels zu
          melden, damit der Reiseveranstalter in die Lage versetzt werden kann,
          die Vertragswidrigkeit – sofern dies je nach Einzelfall möglich ist
          oder tunlich ist – unter Berücksichtigung der jeweiligen Umstände
          (z.B. Zeitverschiebung, Unmöglichkeit der Kontaktaufnahme bei
          Expeditionsreise, Vorliegen einer Alternative bzw. einer
          Austausch-/Verbesserungsmöglichkeit etc.) und des allenfalls damit
          einhergehenden Aufwandes (z.B. Ersatzzimmer säubern, Ersatzhotel
          ausfindig machen), vor Ort zu beheben. Tritt eine Vertragswidrigkeit
          während der üblichen Geschäftszeiten des Reisevermittlers, über den
          die Pauschalreise gebucht wurde, auf, hat der Reisende die
          Vertragswidrigkeit diesem zu melden. Es wird dem Reisenden empfohlen,
          sich dabei insbesondere aus Beweisgründen der Schriftform zu bedienen.
          Außerhalb der üblichen Geschäftszeiten hat der Reisende
          Vertragswidrigkeiten dem Vertreter des Reiseveranstalters vor Ort,
          oder, wenn ein solcher nicht vorhanden und/oder nicht vertraglich
          geschuldet ist, direkt dem Reiseveranstalter unter der im
          Pauschalreisevertrag mitgeteilten Notfallnummer zu melden. Im Falle
          des Unterlassens der Meldung einer Vertragswidrigkeit hat dies, wenn
          Abhilfe vor Ort möglich und eine Meldung auch zumutbar gewesen wäre,
          Auswirkungen auf allfällige gewährleistungsrechtliche Ansprüche des
          Reisenden. Das Unterlassen der Meldung kann gemäß § 12 Abs 2 PRG
          hinsichtlich schadenersatzrechtlicher Ansprüche auch als
          Mitverschulden (§ 1304 ABGB) angerechnet werden. Eine Meldung einer
          Vertragswidrigkeit bewirkt noch keine Leistungszusage des
          Reiseveranstalters.
        </p>

        <p>
          3.8. Der Reisende ist verpflichtet, die im Rahmen des getroffenen
          Vertrages vereinbarten Entgelte gemäß den Zahlungsbestimmungen
          fristgerecht und vollständig zu bezahlen. Der Reisende hält den
          Reisevermittler für den im Fall der Nichtzahlung beim Reisevermittler
          eingetretenen Schaden (Vorauszahlungen des Reisevermittlers) schadlos.
          3.8.1 Eine vollständige Bezahlung ist nur dann gewährleistet, wenn die
          im Vertrag vereinbarten Entgelte auf dem Konto des Reisevermittlers
          oder in Bar eingelangt sind. Zahlungsbelege oder sonstige
          Bankbestätigungen werden nicht als Beweis für eine vollständige
          Bezahlung anerkannt. 3.8.2 Bei nicht vollständiger Bezahlung hält der
          Reisevermittler die Reiseunterlagen zurück und dem Reisenden bleibt
          der Antritt der Reise verwehrt und es besteht kein Anspruch des
          Reisenden auf Erbringung der Reiseleistungen.
        </p>

        <p>
          3.9. Der Reisende hat im Fall der Geltendmachung und des Erhalts von
          Zahlungen aus Schadenersatz- oder Preisminderungsansprüchen im Sinne
          des § 12 Abs 5 PRG (z.B. Ausgleichszahlung gemäß Art 7
          FluggastrechteVO) oder im Falle des Erhalts sonstiger Auszahlungen und
          Leistungen von Leistungsträgern oder von Dritten, die auf
          Schadenersatz- oder Preisminderungsansprüche des Reisenden gegen den
          Reiseveranstalter anzurechnen sind (z.B. Auszahlungen des Hotels), den
          Reisevermittler oder Reiseveranstalter von diesem Umstand vollständig
          und wahrheitsgemäß in Kenntnis zu setzen. Die mehrfache Geltendmachung
          von Ansprüchen durch den Reisenden ist nicht zulässig.
        </p>

        <h3>4. Versicherung</h3>

        <p>
          4.1. Grundsätzlich ist bei Urlaubsreisen zu beachten, dass keine
          wertvollen Gegenstände, wichtige Dokumente etc. mitgenommen werden
          sollten. Bei wichtigen Dokumenten wird die Anfertigung und Verwendung
          von Kopien – soweit deren Gebrauch erlaubt ist - empfohlen. Der
          Diebstahl von Wertgegenständen kann nicht ausgeschlossen werden und
          ist vom Reisenden grundsätzlich selbst, als Verwirklichung des
          allgemeinen Lebensrisikos, zu tragen.
        </p>

        <p>
          4.2. Es wird empfohlen, eine Versicherung
          (Reiserücktrittsversicherung, Reiseabbruchversicherung,
          Reisegepäckversicherung, Reisehaftpflichtversicherung,
          Auslandsreisekrankenversicherung, Verspätungsschutz, Personenschutz
          etc.), welche ausreichende Deckung ab dem Datum des
          Pauschalreisevertrages bis zum Ende der Pauschalreise gewährleistet,
          abzuschließen. Nähere Informationen zu Versicherungen kann der
          Reisende im Katalog des Reiseveranstalters nachlesen.
        </p>

        <h3>5. Pauschalreisevertrag</h3>

        <p>
          5.1. Der Reisende erhält bei Abschluss eines (Pauschal-)Reisevertrages
          oder unverzüglich danach eine Ausfertigung des Vertragsdokuments oder
          eine Bestätigung des Vertrags auf einem dauerhaften Datenträger (z.B.
          Papier, Email). Wird der (Pauschal-)Reisevertrag in gleichzeitiger
          Anwesenheit der Vertragsparteien geschlossen, hat der Reisende
          Anspruch auf eine Papierfassung. Bei außerhalb von Geschäftsräumen
          geschlossenen Verträgen im Sinne des § 3 Z 1 FAGG stimmt der Reisende
          zu, die Ausfertigung oder Bestätigung des Pauschalreisevertrages
          alternativ auch auf einem anderen dauerhaften Datenträger (z.B. Email)
          zur Verfügung gestellt zu bekommen.
        </p>

        <p>
          5.2. Dem Reisenden werden an der zuletzt von ihm bekanntgegebenen
          Zustell-/Kontaktadresse rechtzeitig vor Beginn der Reise, sofern
          nichts anderes vereinbart wurde, die Buchungsbelege, Gutscheine,
          Beförderungsausweise und Eintrittskarten, Informationen zu den
          geplanten voraussichtlichen Abreisezeiten und gegebenenfalls zu
          planmäßigen Zwischenstationen, Anschlussverbindungen und
          Ankunftszeiten zur Verfügung gestellt. Sollten die soeben genannten
          Dokumente/ Unterlagen Unrichtigkeiten /Abweichungen/
          Unvollständigkeiten im Sinne von 3.5. aufweisen, hat der Reisende den
          Reisevermittler oder Reiseveranstalter zu kontaktieren
        </p>

        <h3>6. Preisänderungen vor Reisebeginn</h3>

        <p>
          6.1. Der Reisevermittler setzt den Reisenden an der von ihm zuletzt
          bekanntgegebenen Adresse klar, verständlich und deutlich auf einem
          dauerhaften Datenträger (z.B. Papier, Email) über Preisänderungen im
          Sinne des § 8 PRG, die sich der Reiseveranstalter im
          Pauschalreisevertrag vorbehalten hat, spätestens 20 Tage vor Beginn
          der Pauschalreise unter Angabe der Gründe der Preisänderung, in
          Kenntnis.
        </p>

        <h3>7. Änderungen der Leistung vor Reisebeginn</h3>

        <p>
          7.1. Der Reisevermittler setzt den Reisenden an der von ihm zuletzt
          bekanntgegebenen Adresse klar, verständlich und deutlich auf einem
          dauerhaften Datenträger (z.B. Papier, Email) über unerhebliche
          Änderungen des Inhalts des Pauschalreisevertrages, die sich der
          Reiseveranstalter im Pauschalreisevertrag vorbehalten hat und die er
          einseitig gemäß § 9 Abs 1 PRG vornimmt, in Kenntnis.
        </p>

        <p>
          7.2. Unerhebliche Änderungen sind – wobei dies jeweils im Einzelfall
          zu prüfen ist - geringfügige, sachlich gerechtfertigte Änderungen, die
          den Charakter und/oder die Dauer und/oder den Leistungsinhalt und/oder
          die Qualität der gebuchten Pauschalreise nicht wesentlich verändern.
        </p>

        <p>
          7.3. Bei erheblichen Änderungen kann es sich um eine erhebliche
          Verringerung der Qualität oder des Wertes von Reiseleistungen, zu der
          der Reiseveranstalter gezwungen ist, handeln, wenn die Änderungen
          wesentliche Eigenschaften der Reiseleistungen betreffen und/oder
          Einfluss auf die Pauschalreise und/oder Reiseabwicklung entfalten. Ob
          eine Änderung bzw. Verringerung der Qualität oder des Werts von
          Reiseleistungen erheblich ist, muss im Einzelfall unter Rücksichtnahme
          auf die Art, die Dauer, den Zweck und Preis der Pauschalreise sowie
          unter Rücksichtnahme auf die Intensität und Dauer sowie Ursächlichkeit
          der Änderung und allenfalls auf die Vorwerfbarkeit der Umstände, die
          zur Änderung geführt haben, beurteilt werden.
        </p>

        <p>
          7.4. Ist der Reiseveranstalter gemäß § 9 Abs 2 PRG zu erheblichen
          Änderungen im oben angeführten Sinn jener wesentlichen Eigenschaften
          der Reiseleistungen, die den Charakter und Zweck der Pauschalreise
          ausmachen (vgl 4 Abs 1 Z 1 PRG) gezwungen oder kann er Vorgaben des
          Kunden, die vom Reiseveranstalter ausdrücklich bestätigt wurden, nicht
          erfüllen oder erhöht er den Gesamtpreis der Pauschalreise entsprechend
          den Bestimmungen des § 8 PRG, um mehr als 8 %, kann der Reisende -
          innerhalb einer vom Reiseveranstalter festgelegten angemessenen Frist,
          den vorgeschlagenen Änderungen zustimmen, oder - der Teilnahme an
          einer Ersatzreise zustimmen, sofern diese vom Reiseveranstalter
          angeboten wird, oder - vom Vertrag ohne Zahlung einer Entschädigung
          zurücktreten. Der Reisevermittler informiert daher den Reisenden in
          den eben angeführten Fällen über folgende Punkte an der von ihm
          zuletzt bekanntgegebenen Adresse klar, verständlich und deutlich auf
          einem dauerhaften Datenträger (z.B. Papier, Email): - die Änderungen
          der Reiseleistungen sowie gegebenenfalls deren Auswirkungen auf den
          Preis der Pauschalreise - die angemessene Frist, innerhalb derer der
          Reisende den Reiseveranstalter über seine Entscheidung in Kenntnis zu
          setzen hat, sowie die Rechtswirkung der Nichtabgabe einer Erklärung
          innerhalb der angemessenen Frist, - gegebenenfalls die als Ersatz
          angebotene Pauschalreise und deren Preis. Dem Reisenden wird
          empfohlen, sich bei seiner Erklärung der Schriftform zu bedienen. Gibt
          der Reisende innerhalb der Frist keine Erklärung ab, so gilt dies als
          Zustimmung zu den Änderungen.
        </p>

        <h3>8. Haftung</h3>

        <p>
          8.1. Der Reisevermittler haftet im Rahmen des § 17 PRG für
          Buchungsfehler (z.B. Schreibfehler), sofern diese nicht auf eine
          irrtümliche oder fehlerhafte oder unvollständige Angabe des Reisenden
          oder auf unvermeidbare und außergewöhnliche Umstände im Sinne des § 2
          Abs 12 PRG zurückzuführen sind.
        </p>

        <p>
          8.2. Der Reisevermittler haftet nicht für Sach- und Vermögensschäden
          des Reisenden die im Zusammenhang mit der Buchung entstehen, sofern
          sie auf unvermeidbare und außergewöhnliche Umstände im Sinne des § 2
          Abs 12 PRG zurückzuführen sind.
        </p>

        <p>
          8.3. Der Reisevermittler haftet nicht für die Erbringung der von ihm
          vermittelten Leistung oder für die Erbringung einer Leistung, welche
          nicht von ihm vermittelt worden ist bzw. nicht von ihm zugesagt worden
          ist dem Reisenden zu vermitteln bzw. nicht für vom Reisenden nach
          Reiseantritt selbst gebuchte Zusatzleistungen vor Ort. Kommt der
          Reisevermittler bei der Vermittlung verbundener Reiseleistungen seinen
          Informationspflichten oder Pflichten zur Insolvenzabsicherung im Sinne
          des § 15 Abs 2 PRG nicht nach, haftet er nach den ansonsten nur für
          Pauschalreisen geltenden Bestimmungen der §§ 7 und 10 sowie des 4.
          Abschnitts des PRG.
        </p>

        <p>
          8.4. Vermittelt der Reisevermittler eine Pauschalreise eines
          Reiseveranstalters mit Sitz außerhalb des EWR, hat er nachzuweisen,
          dass der Reiseveranstalter den im 4. Abschnitt des PRG genannten
          Pflichten (Erbringung der vereinbarten Leistungen, Gewährleistung,
          Schadenersatz, Beistandspflicht) nachkommt. Ist dies nicht der Fall,
          haftet der Reisevermittler gemäß § 16 PRG für die Einhaltung der
          genannten Pflichten.
        </p>

        <h3>9. Entgelt des Reisevermittlers</h3>

        <p>
          Dem Reisevermittler steht für seine Tätigkeit ein angemessenes Entgelt
          zu.
        </p>

        <p>
          9.1. Beratungsentgelt: Erstellt der Reisevermittler für den
          Reiseveranstalter ein den Angaben des Reisenden entsprechendes
          Reiseanbot und kommt es nach Überprüfung des Anbotes zu keiner
          Buchung, beträgt das Entgelt für den Beratungsaufwand, sowie die
          Erstellung des Reiseanbots und Recherche, sowie Kommunikation pro
          Reiseanbot EUR 50,00. Der Reisende bekommt dafür einen Reisegutschein
          in der Höhe des Beratungshonorars.
        </p>

        <p>
          9.2. Buchungsentgelt: Kommt es über den Reisevermittler zu einer
          Buchung von Leistungen (z.B. Pauschalreise, Flug, Hotel, Mietwagen
          oder Schiff, etc.) auf Basis des vermittelten Reiseanbots beim
          jeweiligen Reiseveranstalter oder Leistungsträger, beträgt das Entgelt
          pro Buchung und pro Reisenden:
          <ul>
            <li>unter EUR 300,- Auftragswert p.Person € 12,-</li>
            <li>
              Servicepauschale BASIS (ab € 300,- Auftragswert) p.Person € 25,-
            </li>
            <li>
              Servicepauschale PLUS inkl. 2 Zusatzleistungen p.Person € 45,-
            </li>
          </ul>
        </p>

        <p>
          9.3. Kommt es über den Reisevermittler zu einer Buchung von Flügen
          beim jeweiligen Reiseveranstalter oder Leistungsträger, beträgt das
          Entgelt (Flugvermittlungspauschale) pro Reisenden je nach
          Fluggesamtpreis pro Person:
          <ul>
            <li>EUR 50 bis EUR 399 Fluggesamtpreis</li>
            <li>EUR 75 bis EUR 699 Fluggesamtpreis</li>
            <li>EUR 100 bis EUR 999 Fluggesamtpreis</li>
            <li>EUR 130 ab EUR 1.000 Fluggesamtpreis</li>
          </ul>
          Die Vermittlungsleistung des Reisevermittlers ist beendet und mit dem
          Buchungsentgelt abgegolten, sobald ein Vertragsabschluss zwischen dem
          Reisenden und dem vermittelten Reiseveranstalter (z.B. bei
          Pauschalreisen) oder Leistungsträger (z.B. bei einzelnen
          Reiseleistungen wie Flug-only) zustande gekommen ist. Nimmt der
          Reisende den Reisevermittler für weitere über die soeben beschriebene
          Vermittlung hinaus gehende Dienstleistungen in Anspruch, fallen je
          nach Auftrag und Umfang die nachfolgenden Entgelte an:
        </p>

        <p>
          9.4. Umbuchungsentgelt: Beauftragt der Reisende den Reisevermittler
          Änderungen an vermittelten Leistungen vornehmen zu lassen (z.B.
          Umbuchung auf einen anderen Flug), die nicht ihren Ursprung in
          fehlerhaften oder unvollständigen Angaben des Reisenden haben, steht
          dem Reisevermittler pro Auftrag ein Entgelt von EUR 30, zuzüglich der
          Umbuchungsgebühren des Reiseveranstalters oder Leistungsträgers zu.
        </p>

        <p>
          9.5. Stornobearbeitungsentgelt: Kommt es zu einem Rücktritt von
          Leistungen (z.B. Pauschalreisen, Hotel, Mietwagen, Schiff, etc), egal
          ob Reiseabsage durch den Reiseveranstalter oder durch Rücktritt des
          Reisenden, beim jeweiligen Reiseveranstalter oder Leistungsträger,
          wird die Servicepauschale refundiert. Für den Aufwand wird eine
          Stornopauschale verrechnet:
          <ul>
            <li>
              unter EUR 300,- ursprünglichen Auftragswert p.Person € 12,-{" "}
            </li>
            <li>ab EUR 300,- ursprünglichen Auftragswert p.Person € 25,-</li>
            <li>
              bei 2 oder mehr erbrachten Zusatzleistungen p.Person € 45,-{" "}
            </li>
          </ul>
          Kommt es zum Rücktritt eines Fluges, egal ob durch den Reisenden oder
          durch die Fluglinie, wird für den Aufwand zusätzlich eine
          Stornopauschale von € 25,- pro Ticket verrechnet.
        </p>

        <p>
          9.6. Möchte der Reisende den Pauschalreisevertrag im Sinne des § 7 PRG
          auf eine andere Person übertragen lassen, stehen dem Reisevermittler
          die tatsächlichen und nicht unangemessenen Kosten der Übertragung,
          jedenfalls aber eine Bearbeitungsgebühr von EUR 30 zu.
        </p>

        <p>
          9.7. Bearbeitungsentgelt bei fehlerhaften/unvollständigen Angaben des
          Reisenden: Für Änderungen (z.B. Umbuchung, Namensänderung), die
          aufgrund fehlerhafter oder unvollständiger Angaben des Reisenden, die
          der Reisende zu vertreten hat, erforderlich sind, stehen dem
          Reisevermittler analog zu § 7 Abs 2 PRG die tatsächlichen und nicht
          unangemessenen Kosten, jedenfalls EUR 30.- zuzüglich der
          Umbuchungsgebühren des Reiseveranstalters oder Leistungsträgers zu.
        </p>

        <p>
          9.8. Bearbeitungsentgelt zur Unterstützung bei der Abhilfe von
          Leistungsabweichungen bei vermittelten einzelnen Reiseleistungen bzw.
          „Leistungsstörungen“ bei vermittelten Leistungsträgern: Kommt es bei
          vermittelten einzelnen Reiseleistungen zu Abweichungen vom
          ursprünglich vereinbarten Vertragsinhalt (z.B. Annullierung des
          Fluges, Änderung des Abflugortes), ist grundsätzlich der vermittelte
          Leistungsträger verpflichtet Abhilfe zu schaffen (z.B. muss die
          Airline bei Anwendbarkeit der Fluggastrechteverordnung bei einer
          Annullierung dem Reisenden eine anderweitige Beförderung anbieten).
          Kommt der vermittelte Leistungsträger seinen gesetzlichen Pflichten
          nicht oder nur unzureichend nach und beauftragt der Reisende im Rahmen
          der Selbstverbesserung den Reisevermittler mit der Behebung der
          Abweichung (z.B. durch Suche und anschließende Vermittlung passender
          alternativer Flüge), steht dem Reisevermittler für diese zusätzliche
          über die ursprüngliche Vermittlung hinaus gehende Tätigkeit und
          Aufwand je nach Art der Reiseleitung die Servicepauschale bzw.
          Flugvermittlungspauschale (vgl. 9.2 / 9.3) zu.
        </p>

        <h3>10. Reiserücktritt</h3>

        <p>
          10.1. Der Reisende kann jederzeit vor Reisebeginn von der Reise
          zurücktreten. Maßgeblich ist der Zugang der Rücktrittserklärung beim
          Reisevermittler. Zu berücksichtigen sind die üblichen Geschäfts- und
          Bearbeitungszeiten des Reisevermittlers. Dem Reisenden wird empfohlen,
          den Rücktritt in Schriftform zu erklären.
        </p>

        <p>
          10.2. Reisewarnungen des österreichischen Außenministeriums bzw.
          Medienberichte sowie geänderte Einreisebestimmungen in
          Ausgangs-/Zwischen-/Zieldestinationen aufgrund des Coronavirus
          (COVID-19) berechtigen nicht zum kostenlosen Rücktritt, da den
          Reisenden bei Reisebuchung die Gefahrenlage aufgrund der Corona
          Pandemie allgemein bekannt ist.
        </p>

        <p>
          10.3. Im Falle eines Rücktritts stehen dem Reiseveranstalter oder
          Leistungsträger Rücktrittsgebühren lt. Rücktritts- und
          Stornobedingungen zu, die vom Reisenden zu bezahlen sind.
        </p>

        <p>
          10.4. Wenn nicht anders angegeben, beträgt die Storno-/No-Show-Gebühr
          von vermittelten Einzelleistungen, verbundenen Reiseleistungen und
          vermittelten bzw. von KaMikaze Travel selbst veranstalteten
          Pauschalreisen 100% des Reisepreises.
        </p>

        <h3>11. Zustellung - elektronischer Schriftverkehr</h3>

        <p>
          11.1. Als Zustell-/ Kontaktadresse des Reisenden gilt die dem
          Reisevermittler zuletzt bekannt gegebene Adresse (z.B. Email-Adresse).
          Änderungen sind vom Reisenden unverzüglich bekanntzugeben. Es wird dem
          Reisenden empfohlen sich dabei der Schriftform zu bedienen.
        </p>

        <h3>12. Sonstige Bestimmungen</h3>

        <p>
          12.1. Linienflüge: Fluglinien schreiben vor, alle gebuchten
          Flugstrecken zu nutzen. Bei Nichtnutzung einer Teilstrecke kann es von
          der Fluglinie zur Streichung der restlichen Flugstrecken und zu einer
          Nachbelastung kommen. Der Reisevermittler übernimmt keine Haftung im
          Falle einer Streichung und entstehende Nachbelastungen der Fluglinie
          gehen zu vollen Lasten des Reisenden und werden diesem
          weiterverrechnet.
        </p>

        <p>
          12.2. Datenschutzrechtliche Informationspflicht: Die personenbezogenen
          Daten, die der Reisende zur Verfügung stellt, werden elektronisch
          verarbeitet und genutzt, soweit sie zur Vertragsdurchführung
          erforderlich sind. Alle personenbezogenen Daten der Reisenden werden
          nach österreichischen und europäischen Datenschutzrecht bearbeitet.
          Weitere Informationen zum Umgang mit den Daten der Reisenden finden
          Sie in der Datenschutzerklärung des Reisevermittlers unter
          www.kamikaze-travel.at/dsgvo.
        </p>
      </StaticPageLayout>
    </LayoutMain>
  );
}

export default Terms;
